import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any };
};

export type Cidade = {
  __typename?: 'Cidade';
  ativo: Scalars['String']['output'];
  atualizacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  codigo_ibge?: Maybe<Scalars['String']['output']>;
  criacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  data_hora_criacao: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  nome: Scalars['String']['output'];
  uf: Scalars['String']['output'];
  usuario_atualizacao?: Maybe<Usuario>;
  usuario_criacao?: Maybe<Usuario>;
};

export type CidadeDataTable = {
  __typename?: 'CidadeDataTable';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Cidade>>;
};

export type CidadeFilterInput = {
  ativo?: InputMaybe<PrimeFilterItemString>;
  codigo_ibge?: InputMaybe<PrimeFilterItemString>;
  data_hora_criacao?: InputMaybe<PrimeFilterItemString>;
  nome?: InputMaybe<PrimeFilterItemString>;
  uf?: InputMaybe<PrimeFilterItemString>;
};

export type CidadeInput = {
  ativo?: InputMaybe<Scalars['String']['input']>;
  atualizacao_usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  codigo_ibge?: InputMaybe<Scalars['String']['input']>;
  criacao_usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  data_hora_criacao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  uf?: InputMaybe<Scalars['String']['input']>;
};

export type CidadeListInput = {
  filters?: InputMaybe<CidadeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type Contrato = {
  __typename?: 'Contrato';
  ativo: Scalars['String']['output'];
  atualizacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  cidade?: Maybe<Cidade>;
  cidade_id: Scalars['Int']['output'];
  codigo_contrato: Scalars['String']['output'];
  criacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  data_hora_criacao: Scalars['String']['output'];
  descricao: Scalars['String']['output'];
  endereco?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  path_tags?: Maybe<Scalars['String']['output']>;
  periodicidade: Scalars['String']['output'];
  regionais?: Maybe<Array<Regional>>;
  rel_exibir_cidade?: Maybe<Scalars['String']['output']>;
  rel_exibir_coordenada?: Maybe<Scalars['String']['output']>;
  rel_exibir_data?: Maybe<Scalars['String']['output']>;
  usuario_atualizacao?: Maybe<Usuario>;
  usuario_criacao?: Maybe<Usuario>;
};

export type ContratoDataTable = {
  __typename?: 'ContratoDataTable';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Contrato>>;
};

export type ContratoFilterInput = {
  ativo?: InputMaybe<PrimeFilterItemString>;
  cidade_id?: InputMaybe<PrimeFilterItemIntArray>;
  codigo_contrato?: InputMaybe<PrimeFilterItemString>;
  data_hora_criacao?: InputMaybe<PrimeFilterItemString>;
  descricao?: InputMaybe<PrimeFilterItemString>;
  periodicidade?: InputMaybe<PrimeFilterItemString>;
};

export type ContratoInput = {
  ativo?: InputMaybe<Scalars['String']['input']>;
  atualizacao_usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  cidade_id?: InputMaybe<Scalars['Int']['input']>;
  codigo_contrato?: InputMaybe<Scalars['String']['input']>;
  criacao_usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  data_hora_criacao?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  endereco?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  path_tags?: InputMaybe<Scalars['String']['input']>;
  periodicidade?: InputMaybe<Scalars['String']['input']>;
  regionais?: InputMaybe<Array<Scalars['Int']['input']>>;
  rel_exibir_cidade?: InputMaybe<Scalars['String']['input']>;
  rel_exibir_coordenada?: InputMaybe<Scalars['String']['input']>;
  rel_exibir_data?: InputMaybe<Scalars['String']['input']>;
};

export type ContratoListInput = {
  filters?: InputMaybe<ContratoFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type ContratoZip = {
  __typename?: 'ContratoZip';
  arquivo?: Maybe<Scalars['String']['output']>;
  contrato?: Maybe<Contrato>;
  contrato_id: Scalars['Int']['output'];
  criacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  data_hora_criacao: Scalars['String']['output'];
  data_hora_finalizacao?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  mensagem_erro?: Maybe<Scalars['String']['output']>;
  nanoid: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  tamanho_mb?: Maybe<Scalars['Float']['output']>;
  usuario_criacao?: Maybe<Usuario>;
};

export type ContratoZipDataTable = {
  __typename?: 'ContratoZipDataTable';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<ContratoZip>>;
};

export type ContratoZipFilterInput = {
  contrato_id?: InputMaybe<PrimeFilterItemIntArray>;
  data_hora_criacao?: InputMaybe<PrimeFilterItemString>;
  descricao?: InputMaybe<PrimeFilterItemString>;
  status?: InputMaybe<PrimeFilterItemInt>;
};

export type ContratoZipInput = {
  arquivo?: InputMaybe<Scalars['String']['input']>;
  ativo?: InputMaybe<Scalars['String']['input']>;
  contrato_id?: InputMaybe<Scalars['Int']['input']>;
  criacao_usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  data_hora_criacao?: InputMaybe<Scalars['String']['input']>;
  data_hora_finalizacao?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  mensagem_erro?: InputMaybe<Scalars['String']['input']>;
  nanoid?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  tamanho_mb?: InputMaybe<Scalars['Float']['input']>;
};

export type ContratoZipListInput = {
  filters?: InputMaybe<ContratoZipFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type DashboardData = {
  __typename?: 'DashboardData';
  numContratos: Scalars['Int']['output'];
  numFaixas: Scalars['Int']['output'];
  numProgramacoesExecutadas: Scalars['Int']['output'];
  numProgramacoesPendentes: Scalars['Int']['output'];
  numRegistros: Scalars['Int']['output'];
  numSolicitacoesFinalizadas: Scalars['Int']['output'];
  numSolicitacoesPendentes: Scalars['Int']['output'];
};

export type Dispositivo = {
  __typename?: 'Dispositivo';
  ativo?: Maybe<Scalars['String']['output']>;
  atualizacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  criacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  data_hora_ativacao?: Maybe<Scalars['String']['output']>;
  data_hora_atualizacao?: Maybe<Scalars['String']['output']>;
  data_hora_criacao?: Maybe<Scalars['String']['output']>;
  data_hora_desativacao?: Maybe<Scalars['String']['output']>;
  data_hora_ultima_atividade?: Maybe<Scalars['String']['output']>;
  data_ultima_sincronia?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  identificador?: Maybe<Scalars['String']['output']>;
  nanoid: Scalars['String']['output'];
  so?: Maybe<Scalars['String']['output']>;
  usuario_atualizacao?: Maybe<Usuario>;
  usuario_criacao?: Maybe<Usuario>;
};

export type DispositivoDataTable = {
  __typename?: 'DispositivoDataTable';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Dispositivo>>;
};

export type DispositivoFilterInput = {
  ativo?: InputMaybe<PrimeFilterItemString>;
  data_hora_criacao?: InputMaybe<PrimeFilterItemString>;
  descricao?: InputMaybe<PrimeFilterItemString>;
  identificador?: InputMaybe<PrimeFilterItemString>;
};

export type DispositivoInput = {
  ativo?: InputMaybe<Scalars['String']['input']>;
  data_hora_ativacao?: InputMaybe<Scalars['String']['input']>;
  data_hora_atualizacao?: InputMaybe<Scalars['String']['input']>;
  data_hora_criacao?: InputMaybe<Scalars['String']['input']>;
  data_hora_desativacao?: InputMaybe<Scalars['String']['input']>;
  data_hora_ultima_atividade?: InputMaybe<Scalars['String']['input']>;
  data_ultima_sincronia?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  identificador?: InputMaybe<Scalars['String']['input']>;
  nanoid?: InputMaybe<Scalars['String']['input']>;
  so?: InputMaybe<Scalars['String']['input']>;
};

export type DispositivoKey = {
  __typename?: 'DispositivoKey';
  ativo?: Maybe<Scalars['String']['output']>;
  atualizacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  criacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  data_hora_revogacao?: Maybe<Scalars['String']['output']>;
  dispositivo?: Maybe<Dispositivo>;
  dispositivo_nanoid?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  revogado?: Maybe<Scalars['String']['output']>;
  usuario?: Maybe<Usuario>;
  usuario_atualizacao?: Maybe<Usuario>;
  usuario_criacao?: Maybe<Usuario>;
  usuario_nanoid?: Maybe<Scalars['String']['output']>;
};

export type DispositivoKeyInput = {
  ativo?: InputMaybe<Scalars['String']['input']>;
  data_hora_revogacao?: InputMaybe<Scalars['String']['input']>;
  dispositivo_nanoid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  public_key?: InputMaybe<Scalars['String']['input']>;
  revogado?: InputMaybe<Scalars['String']['input']>;
  usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
};

export type DispositivoListInput = {
  filters?: InputMaybe<DispositivoFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type DispositivosInput = {
  dispositivos?: InputMaybe<Array<DispositivoInput>>;
};

export type Evento = {
  __typename?: 'Evento';
  data_hora_criacao: Scalars['String']['output'];
  descricao: Scalars['String']['output'];
  dispositivo?: Maybe<Dispositivo>;
  dispositivo_nanoid: Scalars['String']['output'];
  localizacao?: Maybe<Scalars['String']['output']>;
  nanoid: Scalars['String']['output'];
  sincronizado?: Maybe<Scalars['String']['output']>;
  tipo_evento: Scalars['Int']['output'];
  tipo_log: Scalars['Int']['output'];
  usuario?: Maybe<Usuario>;
  usuario_nanoid: Scalars['String']['output'];
  valores_antigos?: Maybe<Scalars['String']['output']>;
  valores_novos?: Maybe<Scalars['String']['output']>;
};

export type EventoFilterInput = {
  data_hora_criacao?: InputMaybe<PrimeFilterItemStringArray>;
  descricao?: InputMaybe<PrimeFilterItemString>;
  dispositivo_nanoid?: InputMaybe<PrimeFilterItemStringArray>;
  tipo_evento?: InputMaybe<PrimeFilterItemIntArray>;
  usuario_nanoid?: InputMaybe<PrimeFilterItemStringArray>;
};

export type EventoInput = {
  data_hora_criacao?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  dispositivo_nanoid?: InputMaybe<Scalars['String']['input']>;
  localizacao?: InputMaybe<Scalars['String']['input']>;
  nanoid?: InputMaybe<Scalars['String']['input']>;
  sincronizado?: InputMaybe<Scalars['String']['input']>;
  tipo_evento?: InputMaybe<Scalars['Int']['input']>;
  tipo_log?: InputMaybe<Scalars['Int']['input']>;
  usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  valores_antigos?: InputMaybe<Scalars['String']['input']>;
  valores_novos?: InputMaybe<Scalars['String']['input']>;
};

export type EventoListInput = {
  filters?: InputMaybe<EventoFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type EventosInput = {
  eventos?: InputMaybe<Array<EventoInput>>;
};

export type Faixa = {
  __typename?: 'Faixa';
  ativo: Scalars['String']['output'];
  atualizacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  cidade?: Maybe<Cidade>;
  cidade_id?: Maybe<Scalars['Int']['output']>;
  cod_dnit?: Maybe<Scalars['String']['output']>;
  cod_grin?: Maybe<Scalars['String']['output']>;
  codigo_cliente?: Maybe<Scalars['String']['output']>;
  contrato?: Maybe<Contrato>;
  contrato_id: Scalars['Int']['output'];
  criacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  data_hora_criacao: Scalars['String']['output'];
  data_inicio_operacao: Scalars['String']['output'];
  data_venc_afericao?: Maybe<Scalars['String']['output']>;
  data_venc_estudo_tec?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identificacao: Scalars['String']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  local: Scalars['String']['output'];
  longitude?: Maybe<Scalars['String']['output']>;
  lote?: Maybe<Scalars['String']['output']>;
  modelo?: Maybe<Modelo>;
  modelo_id: Scalars['Int']['output'];
  num_serie: Scalars['String']['output'];
  regional?: Maybe<Regional>;
  regional_id: Scalars['Int']['output'];
  registros?: Maybe<Array<Registro>>;
  rota?: Maybe<Rota>;
  rota_id: Scalars['Int']['output'];
  sentido: Scalars['String']['output'];
  tipo: Scalars['Int']['output'];
  tipo_capturas?: Maybe<Array<TipoCaptura>>;
  FaixaTipoCapturas?: Maybe<Array<FaixaTipoCaptura>>;
  data_afericao?: Maybe<Scalars['String']['output']>;
  no_laudo?: Maybe<Scalars['String']['output']>;
  usuario_atualizacao?: Maybe<Usuario>;
  usuario_criacao?: Maybe<Usuario>;
};

export type FaixaTipoCaptura = {
  __typename?: 'FaixaTipoCaptura';
  faixa_id: Scalars['Int']['output'];
  tipo_captura_id: Scalars['Int']['output'];
  replicar_de_faixa_id?: Maybe<Scalars['Int']['output']>;
};

export type FaixaDataTable = {
  __typename?: 'FaixaDataTable';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Faixa>>;
};

export type FaixaFilterInput = {
  ativo?: InputMaybe<PrimeFilterItemString>;
  cidade_id?: InputMaybe<PrimeFilterItemIntArray>;
  codigo_cliente?: InputMaybe<PrimeFilterItemString>;
  contrato_id?: InputMaybe<PrimeFilterItemIntArray>;
  data_hora_criacao?: InputMaybe<PrimeFilterItemString>;
  identificacao?: InputMaybe<PrimeFilterItemString>;
  marca_id?: InputMaybe<PrimeFilterItemIntArray>;
  modelo_id?: InputMaybe<PrimeFilterItemIntArray>;
  num_serie?: InputMaybe<PrimeFilterItemString>;
  regional_id?: InputMaybe<PrimeFilterItemIntArray>;
  rota_id?: InputMaybe<PrimeFilterItemIntArray>;
  tipo?: InputMaybe<PrimeFilterItemInt>;
};

export type FaixaInput = {
  ativo?: InputMaybe<Scalars['String']['input']>;
  atualizacao_usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  cidade_id?: InputMaybe<Scalars['Int']['input']>;
  cod_dnit?: InputMaybe<Scalars['String']['input']>;
  cod_grin?: InputMaybe<Scalars['String']['input']>;
  codigo_cliente?: InputMaybe<Scalars['String']['input']>;
  contrato_id?: InputMaybe<Scalars['Int']['input']>;
  criacao_usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  data_hora_criacao?: InputMaybe<Scalars['String']['input']>;
  data_inicio_operacao?: InputMaybe<Scalars['String']['input']>;
  data_venc_afericao?: InputMaybe<Scalars['String']['input']>;
  data_venc_estudo_tec?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  identificacao?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  local?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  lote?: InputMaybe<Scalars['String']['input']>;
  modelo_id?: InputMaybe<Scalars['Int']['input']>;
  num_serie?: InputMaybe<Scalars['String']['input']>;
  regional_id?: InputMaybe<Scalars['Int']['input']>;
  rota_id?: InputMaybe<Scalars['Int']['input']>;
  sentido?: InputMaybe<Scalars['String']['input']>;
  tipo?: InputMaybe<Scalars['Int']['input']>;
  tipo_capturas?: InputMaybe<Array<Scalars['Int']['input']>>;
  tipo_capturas_replicacao?: InputMaybe<
    Array<FaixaTipoCapturaReplicacaoInput>
  >;
};

export type FaixaTipoCapturaReplicacaoInput = {
  tipo_captura_id: Scalars['Int']['input'];
  replicar_de_faixa_id?: InputMaybe<Scalars['Int']['input']>;
};

export type FaixaListInput = {
  filters?: InputMaybe<FaixaFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type GrupoSistema = {
  __typename?: 'GrupoSistema';
  ativo: Scalars['String']['output'];
  descricao?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  nome: Scalars['String']['output'];
  permissoes?: Maybe<Array<Permissao>>;
};

export type GrupoSistemaDataTable = {
  __typename?: 'GrupoSistemaDataTable';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<GrupoSistema>>;
};

export type GrupoSistemaFilterInput = {
  nome?: InputMaybe<PrimeFilterItemString>;
};

export type GrupoSistemaInput = {
  ativo?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  permissoes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GrupoSistemaListInput = {
  filters?: InputMaybe<GrupoSistemaFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type HistoricoAcesso = {
  __typename?: 'HistoricoAcesso';
  data_hora_entrada?: Maybe<Scalars['String']['output']>;
  data_hora_saida?: Maybe<Scalars['String']['output']>;
  dispositivo?: Maybe<Dispositivo>;
  dispositivo_nanoid: Scalars['String']['output'];
  nanoid: Scalars['String']['output'];
  sincronizado: Scalars['String']['output'];
  status: Scalars['String']['output'];
  usuario?: Maybe<Usuario>;
  usuario_nanoid: Scalars['String']['output'];
};

export type HistoricoAcessoDataTable = {
  __typename?: 'HistoricoAcessoDataTable';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<HistoricoAcesso>>;
};

export type HistoricoAcessoFilterInput = {
  data_hora_entrada?: InputMaybe<PrimeFilterItemStringArray>;
  data_hora_saida?: InputMaybe<PrimeFilterItemStringArray>;
  dispositivo_nanoid?: InputMaybe<PrimeFilterItemStringArray>;
  usuario_nanoid?: InputMaybe<PrimeFilterItemStringArray>;
};

export type HistoricoAcessoInput = {
  ativo?: InputMaybe<Scalars['String']['input']>;
  data_hora_entrada?: InputMaybe<Scalars['String']['input']>;
  data_hora_saida?: InputMaybe<Scalars['String']['input']>;
  dispositivo_nanoid?: InputMaybe<Scalars['String']['input']>;
  nanoid?: InputMaybe<Scalars['String']['input']>;
  sincronizado?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
};

export type HistoricoAcessoListInput = {
  filters?: InputMaybe<HistoricoAcessoFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type HistoricosAcessoInput = {
  historicos_acesso?: InputMaybe<Array<HistoricoAcessoInput>>;
};

export type ImportInfo = {
  __typename?: 'ImportInfo';
  canCreate?: Maybe<Scalars['Boolean']['output']>;
  canUpdate?: Maybe<Scalars['Boolean']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  modelName: Scalars['String']['output'];
  updated?: Maybe<Scalars['Int']['output']>;
};

export type LocalFile = {
  __typename?: 'LocalFile';
  path: Scalars['String']['output'];
};

export type Marca = {
  __typename?: 'Marca';
  ativo: Scalars['String']['output'];
  atualizacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  criacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  data_hora_criacao: Scalars['String']['output'];
  descricao: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  usuario_atualizacao?: Maybe<Usuario>;
  usuario_criacao?: Maybe<Usuario>;
};

export type MarcaDataTable = {
  __typename?: 'MarcaDataTable';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Marca>>;
};

export type MarcaFilterInput = {
  ativo?: InputMaybe<PrimeFilterItemString>;
  data_hora_criacao?: InputMaybe<PrimeFilterItemString>;
  descricao?: InputMaybe<PrimeFilterItemString>;
};

export type MarcaInput = {
  ativo?: InputMaybe<Scalars['String']['input']>;
  atualizacao_usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  criacao_usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  data_hora_criacao?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type MarcaListInput = {
  filters?: InputMaybe<MarcaFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type Modelo = {
  __typename?: 'Modelo';
  ativo: Scalars['String']['output'];
  atualizacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  criacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  data_hora_criacao: Scalars['String']['output'];
  descricao: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  marca?: Maybe<Marca>;
  marca_id: Scalars['Int']['output'];
  usuario_atualizacao?: Maybe<Usuario>;
  usuario_criacao?: Maybe<Usuario>;
};

export type ModeloDataTable = {
  __typename?: 'ModeloDataTable';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Modelo>>;
};

export type ModeloFilterInput = {
  ativo?: InputMaybe<PrimeFilterItemString>;
  data_hora_criacao?: InputMaybe<PrimeFilterItemString>;
  descricao?: InputMaybe<PrimeFilterItemString>;
  marca_id?: InputMaybe<PrimeFilterItemIntArray>;
};

export type ModeloInput = {
  ativo?: InputMaybe<Scalars['String']['input']>;
  atualizacao_usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  criacao_usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  data_hora_criacao?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  marca_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ModeloListInput = {
  filters?: InputMaybe<ModeloFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type MotivoAusencia = {
  __typename?: 'MotivoAusencia';
  ativo: Scalars['String']['output'];
  atualizacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  criacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  data_hora_criacao: Scalars['String']['output'];
  descricao: Scalars['String']['output'];
  nanoid: Scalars['String']['output'];
  usuario_atualizacao?: Maybe<Usuario>;
  usuario_criacao?: Maybe<Usuario>;
};

export type MotivoAusenciaDataTable = {
  __typename?: 'MotivoAusenciaDataTable';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<MotivoAusencia>>;
};

export type MotivoAusenciaFilterInput = {
  ativo?: InputMaybe<PrimeFilterItemString>;
  data_hora_criacao?: InputMaybe<PrimeFilterItemString>;
  descricao?: InputMaybe<PrimeFilterItemString>;
};

export type MotivoAusenciaInput = {
  ativo?: InputMaybe<Scalars['String']['input']>;
  atualizacao_usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  criacao_usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  data_hora_criacao?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  nanoid?: InputMaybe<Scalars['String']['input']>;
};

export type MotivoAusenciaListInput = {
  filters?: InputMaybe<MotivoAusenciaFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  alterarSenhaUsuario?: Maybe<UsuarioFullData>;
  alterarSenhaUsuarioRetaguarda?: Maybe<UsuarioFullData>;
  ativarDesativarDispositivos?: Maybe<Array<Dispositivo>>;
  ativarDesativarUsuarios?: Maybe<Array<Usuario>>;
  criarAlterarCidade?: Maybe<Cidade>;
  criarAlterarContrato?: Maybe<Contrato>;
  criarAlterarContratoZip?: Maybe<ContratoZip>;
  criarAlterarDispositivo?: Maybe<Dispositivo>;
  criarAlterarDispositivoKey?: Maybe<DispositivoKey>;
  criarAlterarFaixa?: Maybe<Faixa>;
  criarAlterarGrupoSistema?: Maybe<GrupoSistema>;
  criarAlterarMarca?: Maybe<Marca>;
  criarAlterarModelo?: Maybe<Modelo>;
  criarAlterarMotivoAusencia?: Maybe<MotivoAusencia>;
  criarAlterarParametro?: Maybe<Parametro>;
  criarAlterarProgramacao?: Maybe<Programacao>;
  criarAlterarRegional?: Maybe<Regional>;
  criarAlterarRegistro?: Maybe<Registro>;
  criarAlterarRegistroCaptura?: Maybe<RegistroCaptura>;
  criarAlterarRota?: Maybe<Rota>;
  criarAlterarSolicitacao?: Maybe<Solicitacao>;
  criarAlterarTipoCaptura?: Maybe<TipoCaptura>;
  criarAlterarUsuario?: Maybe<Usuario>;
  criarAlterarVariasSolicitacoes?: Maybe<Array<Solicitacao>>;
  criarAlterarVariosEventos?: Maybe<Array<Evento>>;
  criarAlterarVariosHistoricosAcesso?: Maybe<Array<HistoricoAcesso>>;
  criarAlterarVariosRegistros?: Maybe<Array<Registro>>;
  criarVariasSolicitacoes?: Maybe<Array<Solicitacao>>;
  gerarZipContrato?: Maybe<Scalars['String']['output']>;
  importCsv?: Maybe<ImportInfo>;
  incluirCapturasNoRegistro?: Maybe<Array<RegistroCaptura>>;
  registrarFirebaseToken?: Maybe<Dispositivo>;
  solicitarLogoutNoDispositivo?: Maybe<HistoricoAcesso>;
  uploadFile?: Maybe<LocalFile>;
};

export type MutationAlterarSenhaUsuarioArgs = {
  data: UsuarioAlterarSenhaInput;
};

export type MutationAlterarSenhaUsuarioRetaguardaArgs = {
  data: UsuarioAlterarSenhaInput;
};

export type MutationAtivarDesativarDispositivosArgs = {
  data: DispositivosInput;
};

export type MutationAtivarDesativarUsuariosArgs = {
  data: UsuariosInput;
};

export type MutationCriarAlterarCidadeArgs = {
  data: CidadeInput;
};

export type MutationCriarAlterarContratoArgs = {
  data: ContratoInput;
};

export type MutationCriarAlterarContratoZipArgs = {
  data: ContratoZipInput;
};

export type MutationCriarAlterarDispositivoArgs = {
  data: DispositivoInput;
};

export type MutationCriarAlterarDispositivoKeyArgs = {
  data: DispositivoKeyInput;
};

export type MutationCriarAlterarFaixaArgs = {
  data: FaixaInput;
};

export type MutationCriarAlterarGrupoSistemaArgs = {
  data: GrupoSistemaInput;
};

export type MutationCriarAlterarMarcaArgs = {
  data: MarcaInput;
};

export type MutationCriarAlterarModeloArgs = {
  data: ModeloInput;
};

export type MutationCriarAlterarMotivoAusenciaArgs = {
  data: MotivoAusenciaInput;
};

export type MutationCriarAlterarParametroArgs = {
  data: ParametroInput;
};

export type MutationCriarAlterarProgramacaoArgs = {
  data: ProgramacaoInput;
};

export type MutationCriarAlterarRegionalArgs = {
  data: RegionalInput;
};

export type MutationCriarAlterarRegistroArgs = {
  data: RegistroInput;
};

export type MutationCriarAlterarRegistroCapturaArgs = {
  data: RegistroCapturaInput;
};

export type MutationCriarAlterarRotaArgs = {
  data: RotaInput;
};

export type MutationCriarAlterarSolicitacaoArgs = {
  data: SolicitacaoInput;
};

export type MutationCriarAlterarTipoCapturaArgs = {
  data: TipoCapturaInput;
};

export type MutationCriarAlterarUsuarioArgs = {
  data: UsuarioInput;
};

export type MutationCriarAlterarVariasSolicitacoesArgs = {
  data: SolicitacoesInput;
};

export type MutationCriarAlterarVariosEventosArgs = {
  data: EventosInput;
};

export type MutationCriarAlterarVariosHistoricosAcessoArgs = {
  data: HistoricosAcessoInput;
};

export type MutationCriarAlterarVariosRegistrosArgs = {
  data: RegistrosInput;
};

export type MutationCriarVariasSolicitacoesArgs = {
  data: SolicitacaoInput;
};

export type MutationGerarZipContratoArgs = {
  data: ZipFileInput;
};

export type MutationImportCsvArgs = {
  file: Scalars['Upload']['input'];
  modelName: Scalars['String']['input'];
};

export type MutationIncluirCapturasNoRegistroArgs = {
  data: RegistroSolicitacaoInput;
};

export type MutationRegistrarFirebaseTokenArgs = {
  firebase_token: Scalars['String']['input'];
};

export type MutationSolicitarLogoutNoDispositivoArgs = {
  historicoNanoid: Scalars['String']['input'];
};

export type MutationUploadFileArgs = {
  dir: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
  preferedPath?: InputMaybe<Scalars['String']['input']>;
};

export type Parametro = {
  __typename?: 'Parametro';
  data_hora_criacao?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  grupo?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  tipo: Scalars['String']['output'];
  tipo_valor?: Maybe<Scalars['String']['output']>;
  valor?: Maybe<Scalars['String']['output']>;
};

export type ParametroDataTable = {
  __typename?: 'ParametroDataTable';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Parametro>>;
};

export type ParametroFilterInput = {
  descricao?: InputMaybe<PrimeFilterItemString>;
  grupo?: InputMaybe<PrimeFilterItemString>;
  tipo?: InputMaybe<PrimeFilterItemString>;
};

export type ParametroInput = {
  ativo?: InputMaybe<Scalars['String']['input']>;
  data_hora_criacao?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  grupo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  tipo?: InputMaybe<Scalars['String']['input']>;
  tipo_valor?: InputMaybe<Scalars['String']['input']>;
  valor?: InputMaybe<Scalars['String']['input']>;
};

export type ParametroListInput = {
  filters?: InputMaybe<ParametroFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type Permissao = {
  __typename?: 'Permissao';
  ativo: Scalars['String']['output'];
  categoria: Scalars['String']['output'];
  descricao: Scalars['String']['output'];
  nanoid: Scalars['String']['output'];
  tipo_usuario?: Maybe<Scalars['Int']['output']>;
};

export type PrimeFilterItemInt = {
  matchMode?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type PrimeFilterItemIntArray = {
  matchMode?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PrimeFilterItemString = {
  matchMode?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PrimeFilterItemStringArray = {
  matchMode?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Programacao = {
  __typename?: 'Programacao';
  ano?: Maybe<Scalars['Int']['output']>;
  ativo: Scalars['String']['output'];
  contrato?: Maybe<Contrato>;
  contrato_id: Scalars['Int']['output'];
  data_hora_criacao: Scalars['String']['output'];
  data_hora_execucao?: Maybe<Scalars['String']['output']>;
  executado: Scalars['String']['output'];
  faixa?: Maybe<Faixa>;
  faixa_id: Scalars['Int']['output'];
  mes?: Maybe<Scalars['Int']['output']>;
  motivo_ausencia?: Maybe<Scalars['String']['output']>;
  motivo_ausencia_obs?: Maybe<Scalars['String']['output']>;
  nanoid: Scalars['String']['output'];
  periodicidade: Scalars['String']['output'];
  quinzena?: Maybe<Scalars['Int']['output']>;
  sincronizado: Scalars['String']['output'];
  usuario_execucao?: Maybe<Usuario>;
  usuario_execucao_nanoid?: Maybe<Scalars['String']['output']>;
};

export type ProgramacaoDataTable = {
  __typename?: 'ProgramacaoDataTable';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Programacao>>;
};

export type ProgramacaoFilterInput = {
  ano?: InputMaybe<PrimeFilterItemInt>;
  ativo?: InputMaybe<PrimeFilterItemString>;
  contrato_id?: InputMaybe<PrimeFilterItemIntArray>;
  data_hora_criacao?: InputMaybe<PrimeFilterItemString>;
  executado?: InputMaybe<PrimeFilterItemString>;
  faixa_id?: InputMaybe<PrimeFilterItemIntArray>;
  mes?: InputMaybe<PrimeFilterItemInt>;
  motivo_ausencia?: InputMaybe<PrimeFilterItemStringArray>;
  periodicidade?: InputMaybe<PrimeFilterItemString>;
  quinzena?: InputMaybe<PrimeFilterItemInt>;
  sincronizado?: InputMaybe<PrimeFilterItemString>;
  usuario_execucao_nanoid?: InputMaybe<PrimeFilterItemString>;
};

export type ProgramacaoInput = {
  ano?: InputMaybe<Scalars['Int']['input']>;
  ativo?: InputMaybe<Scalars['String']['input']>;
  contrato_id?: InputMaybe<Scalars['Int']['input']>;
  data_hora_criacao?: InputMaybe<Scalars['String']['input']>;
  data_hora_execucao?: InputMaybe<Scalars['String']['input']>;
  executado?: InputMaybe<Scalars['String']['input']>;
  faixa_id?: InputMaybe<Scalars['Int']['input']>;
  mes?: InputMaybe<Scalars['Int']['input']>;
  motivo_ausencia?: InputMaybe<Scalars['String']['input']>;
  motivo_ausencia_obs?: InputMaybe<Scalars['String']['input']>;
  nanoid?: InputMaybe<Scalars['String']['input']>;
  periodicidade?: InputMaybe<Scalars['String']['input']>;
  quinzena?: InputMaybe<Scalars['Int']['input']>;
  sincronizado?: InputMaybe<Scalars['String']['input']>;
  usuario_execucao_nanoid?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramacaoListInput = {
  filters?: InputMaybe<ProgramacaoFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type Query = {
  __typename?: 'Query';
  buscarCidadePorId?: Maybe<Cidade>;
  buscarContratoPorId?: Maybe<Contrato>;
  buscarContratoZipPorId?: Maybe<ContratoZip>;
  buscarDispositivoKeyPorDispositivo?: Maybe<DispositivoKey>;
  buscarDispositivoPorId?: Maybe<Dispositivo>;
  buscarEventoDispositivoPorId?: Maybe<Evento>;
  buscarEventoSitePorId?: Maybe<Evento>;
  buscarFaixaPorId?: Maybe<Faixa>;
  buscarGrupo?: Maybe<Array<Parametro>>;
  buscarGrupoSistemaPorId?: Maybe<GrupoSistema>;
  buscarHistoricoAcessoPorId?: Maybe<HistoricoAcesso>;
  buscarMarcaPorId?: Maybe<Marca>;
  buscarModeloPorId?: Maybe<Modelo>;
  buscarMotivoAusenciaPorId?: Maybe<MotivoAusencia>;
  buscarParametro?: Maybe<Array<Parametro>>;
  buscarParametroPorId?: Maybe<Parametro>;
  buscarParametroPorTipo?: Maybe<Parametro>;
  buscarProgramacaoPorId?: Maybe<Programacao>;
  buscarRegionalPorId?: Maybe<Regional>;
  buscarRegistroCapturaPorId?: Maybe<RegistroCaptura>;
  buscarRegistroPorId?: Maybe<Registro>;
  buscarRotaPorId?: Maybe<Rota>;
  buscarSolicitacaoPorId?: Maybe<Solicitacao>;
  buscarTipoCapturaPorId?: Maybe<TipoCaptura>;
  buscarUsuarioPorId?: Maybe<Usuario>;
  filtrarCidade?: Maybe<CidadeDataTable>;
  filtrarContrato?: Maybe<ContratoDataTable>;
  filtrarContratoZip?: Maybe<ContratoZipDataTable>;
  filtrarDashboard: DashboardData;
  filtrarDispositivo?: Maybe<DispositivoDataTable>;
  filtrarEventoDispositivo?: Maybe<Array<Evento>>;
  filtrarEventoSite?: Maybe<Array<Evento>>;
  filtrarFaixa?: Maybe<FaixaDataTable>;
  filtrarGrupoSistema?: Maybe<GrupoSistemaDataTable>;
  filtrarHistoricoAcesso?: Maybe<HistoricoAcessoDataTable>;
  filtrarMarca?: Maybe<MarcaDataTable>;
  filtrarModelo?: Maybe<ModeloDataTable>;
  filtrarMotivoAusencia?: Maybe<MotivoAusenciaDataTable>;
  filtrarParametro?: Maybe<ParametroDataTable>;
  filtrarProgramacao?: Maybe<ProgramacaoDataTable>;
  filtrarRegional?: Maybe<RegionalDataTable>;
  filtrarRegistro?: Maybe<RegistroDataTable>;
  filtrarRegistroCaptura?: Maybe<RegistroCapturaDataTable>;
  filtrarRelatorioFaixa?: Maybe<Array<Faixa>>;
  filtrarRota?: Maybe<RotaDataTable>;
  filtrarSolicitacao?: Maybe<SolicitacaoDataTable>;
  filtrarTipoCaptura?: Maybe<TipoCapturaDataTable>;
  filtrarUsuario?: Maybe<UsuarioDataTable>;
  gerarProgramacao?: Maybe<Array<Programacao>>;
  listarCidade?: Maybe<Array<Cidade>>;
  listarCidadeAtivo?: Maybe<Array<Cidade>>;
  listarContrato?: Maybe<Array<Contrato>>;
  listarContratoAtivo?: Maybe<Array<Contrato>>;
  listarContratoZip?: Maybe<Array<ContratoZip>>;
  listarContratoZipAtivo?: Maybe<Array<ContratoZip>>;
  listarDispositivos?: Maybe<Array<Dispositivo>>;
  listarDispositivosAtivos?: Maybe<Array<Dispositivo>>;
  listarFaixa?: Maybe<Array<Faixa>>;
  listarFaixaAtivo?: Maybe<Array<Faixa>>;
  listarGrupoSistema?: Maybe<Array<GrupoSistema>>;
  listarHistoricoAcesso?: Maybe<Array<HistoricoAcesso>>;
  listarMarca?: Maybe<Array<Marca>>;
  listarMarcaAtivo?: Maybe<Array<Marca>>;
  listarModelo?: Maybe<Array<Modelo>>;
  listarModeloAtivo?: Maybe<Array<Modelo>>;
  listarMotivoAusencia?: Maybe<Array<MotivoAusencia>>;
  listarMotivoAusenciaAtivo?: Maybe<Array<MotivoAusencia>>;
  listarParametro?: Maybe<Array<Parametro>>;
  listarParametroPorTipo?: Maybe<Array<Parametro>>;
  listarPermissoes?: Maybe<Array<Permissao>>;
  listarProgramacao?: Maybe<Array<Programacao>>;
  listarProgramacaoAtivo?: Maybe<Array<Programacao>>;
  listarRegional?: Maybe<Array<Regional>>;
  listarRegionalAtivo?: Maybe<Array<Regional>>;
  listarRegistro?: Maybe<Array<Registro>>;
  listarRegistroAtivo?: Maybe<Array<Registro>>;
  listarRegistroCaptura?: Maybe<Array<RegistroCaptura>>;
  listarRegistroCapturaAtivo?: Maybe<Array<RegistroCaptura>>;
  listarRegistroPorSolicitacao?: Maybe<Array<Registro>>;
  listarRota?: Maybe<Array<Rota>>;
  listarRotaAtivo?: Maybe<Array<Rota>>;
  listarSolicitacao?: Maybe<Array<Solicitacao>>;
  listarSolicitacaoAtivo?: Maybe<Array<Solicitacao>>;
  listarTipoCaptura?: Maybe<Array<TipoCaptura>>;
  listarTipoCapturaAtivo?: Maybe<Array<TipoCaptura>>;
  listarTipoCapturaPorFaixa?: Maybe<Array<TipoCaptura>>;
  listarUsuarios?: Maybe<Array<Usuario>>;
  listarUsuariosDispositivo?: Maybe<Array<Usuario>>;
  listarUsuariosLogadosPorDispositivo?: Maybe<Array<HistoricoAcesso>>;
  listarUsuariosRetaguarda?: Maybe<Array<Usuario>>;
  login?: Maybe<Usuario>;
  signUrl?: Maybe<SignUrl>;
  sincronizarCidade?: Maybe<Array<Cidade>>;
  sincronizarContrato?: Maybe<Array<Contrato>>;
  sincronizarDispositivo?: Maybe<Dispositivo>;
  sincronizarEventos?: Maybe<Array<Evento>>;
  sincronizarFaixa?: Maybe<Array<Faixa>>;
  sincronizarHistoricoAcesso?: Maybe<Array<HistoricoAcesso>>;
  sincronizarKeyDispositivo?: Maybe<SincronizacaoDataResponse>;
  sincronizarMarca?: Maybe<Array<Marca>>;
  sincronizarModelo?: Maybe<Array<Modelo>>;
  sincronizarMotivoAusencia?: Maybe<Array<MotivoAusencia>>;
  sincronizarParametro?: Maybe<Array<Parametro>>;
  sincronizarProgramacao?: Maybe<Array<Programacao>>;
  sincronizarRegional?: Maybe<Array<Regional>>;
  sincronizarRegistro?: Maybe<Array<Registro>>;
  sincronizarRegistroCaptura?: Maybe<Array<RegistroCaptura>>;
  sincronizarRota?: Maybe<Array<Rota>>;
  sincronizarSincronizacaoTabela?: Maybe<Array<Sincronizacao>>;
  sincronizarSolicitacao?: Maybe<Array<Solicitacao>>;
  sincronizarTipoCaptura?: Maybe<Array<TipoCaptura>>;
  sincronizarUsuarios?: Maybe<Array<UsuarioFullData>>;
  usuarioLogado?: Maybe<Usuario>;
};

export type QueryBuscarCidadePorIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryBuscarContratoPorIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryBuscarContratoZipPorIdArgs = {
  nanoid: Scalars['String']['input'];
};

export type QueryBuscarDispositivoKeyPorDispositivoArgs = {
  nanoid: Scalars['String']['input'];
};

export type QueryBuscarDispositivoPorIdArgs = {
  nanoid: Scalars['String']['input'];
};

export type QueryBuscarEventoDispositivoPorIdArgs = {
  nanoid: Scalars['String']['input'];
};

export type QueryBuscarEventoSitePorIdArgs = {
  nanoid: Scalars['String']['input'];
};

export type QueryBuscarFaixaPorIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryBuscarGrupoSistemaPorIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryBuscarHistoricoAcessoPorIdArgs = {
  nanoid: Scalars['String']['input'];
};

export type QueryBuscarMarcaPorIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryBuscarModeloPorIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryBuscarMotivoAusenciaPorIdArgs = {
  nanoid: Scalars['String']['input'];
};

export type QueryBuscarParametroArgs = {
  tipos: Array<Scalars['String']['input']>;
};

export type QueryBuscarParametroPorIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryBuscarParametroPorTipoArgs = {
  tipo: Scalars['String']['input'];
};

export type QueryBuscarProgramacaoPorIdArgs = {
  nanoid: Scalars['String']['input'];
};

export type QueryBuscarRegionalPorIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryBuscarRegistroCapturaPorIdArgs = {
  nanoid: Scalars['String']['input'];
};

export type QueryBuscarRegistroPorIdArgs = {
  nanoid: Scalars['String']['input'];
};

export type QueryBuscarRotaPorIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryBuscarSolicitacaoPorIdArgs = {
  nanoid: Scalars['String']['input'];
};

export type QueryBuscarTipoCapturaPorIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryBuscarUsuarioPorIdArgs = {
  nanoid: Scalars['String']['input'];
};

export type QueryFiltrarCidadeArgs = {
  filter: CidadeListInput;
};

export type QueryFiltrarContratoArgs = {
  filter: ContratoListInput;
};

export type QueryFiltrarContratoZipArgs = {
  filter: ContratoZipListInput;
};

export type QueryFiltrarDashboardArgs = {
  ano: Scalars['Int']['input'];
  mes: Scalars['Int']['input'];
};

export type QueryFiltrarDispositivoArgs = {
  filter: DispositivoListInput;
};

export type QueryFiltrarEventoDispositivoArgs = {
  filter: EventoListInput;
};

export type QueryFiltrarEventoSiteArgs = {
  filter: EventoListInput;
};

export type QueryFiltrarFaixaArgs = {
  filter: FaixaListInput;
};

export type QueryFiltrarGrupoSistemaArgs = {
  filter: GrupoSistemaListInput;
};

export type QueryFiltrarHistoricoAcessoArgs = {
  filter: HistoricoAcessoListInput;
};

export type QueryFiltrarMarcaArgs = {
  filter: MarcaListInput;
};

export type QueryFiltrarModeloArgs = {
  filter: ModeloListInput;
};

export type QueryFiltrarMotivoAusenciaArgs = {
  filter: MotivoAusenciaListInput;
};

export type QueryFiltrarParametroArgs = {
  filter: ParametroListInput;
};

export type QueryFiltrarProgramacaoArgs = {
  filter: ProgramacaoListInput;
};

export type QueryFiltrarRegionalArgs = {
  filter: RegionalListInput;
};

export type QueryFiltrarRegistroArgs = {
  filter: RegistroListInput;
};

export type QueryFiltrarRegistroCapturaArgs = {
  filter: RegistroCapturaListInput;
};

export type QueryFiltrarRelatorioFaixaArgs = {
  filter: RelatorioFaixaInput;
};

export type QueryFiltrarRotaArgs = {
  filter: RotaListInput;
};

export type QueryFiltrarSolicitacaoArgs = {
  filter: SolicitacaoListInput;
};

export type QueryFiltrarTipoCapturaArgs = {
  filter: TipoCapturaListInput;
};

export type QueryFiltrarUsuarioArgs = {
  filter: UsuarioListInput;
};

export type QueryListarParametroPorTipoArgs = {
  tipos: Array<Scalars['String']['input']>;
};

export type QueryListarRegistroPorSolicitacaoArgs = {
  solicitacao_nanoid: Scalars['String']['input'];
};

export type QueryListarTipoCapturaPorFaixaArgs = {
  faixaId: Scalars['Int']['input'];
};

export type QueryListarUsuariosLogadosPorDispositivoArgs = {
  dispositivoNanoid: Scalars['String']['input'];
};

export type QueryLoginArgs = {
  data: UsuarioLoginInput;
};

export type QuerySignUrlArgs = {
  url: Scalars['String']['input'];
};

export type QuerySincronizarKeyDispositivoArgs = {
  data: SincronizacaoDispositivoInput;
};
export type GerarPlanilhaRelatorioFotosMutationVariables = Exact<{
  filter: RelatorioFaixaInput;
}>;

export type GerarPlanilhaRelatorioFotosMutation = {
  __typename?: 'Mutation';
  gerarPlanilhaRelatorioFotos?: string | null;
};

export type Regional = {
  __typename?: 'Regional';
  ativo: Scalars['String']['output'];
  atualizacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  contratos?: Maybe<Array<Contrato>>;
  criacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  data_hora_criacao: Scalars['String']['output'];
  descricao: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  usuario_atualizacao?: Maybe<Usuario>;
  usuario_criacao?: Maybe<Usuario>;
};

export type RegionalDataTable = {
  __typename?: 'RegionalDataTable';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Regional>>;
};

export type RegionalFilterInput = {
  ativo?: InputMaybe<PrimeFilterItemString>;
  data_hora_criacao?: InputMaybe<PrimeFilterItemString>;
  descricao?: InputMaybe<PrimeFilterItemString>;
};

export type RegionalInput = {
  ativo?: InputMaybe<Scalars['String']['input']>;
  atualizacao_usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  criacao_usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  data_hora_criacao?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type RegionalListInput = {
  filters?: InputMaybe<RegionalFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type Registro = {
  __typename?: 'Registro';
  ativo: Scalars['String']['output'];
  capturas?: Maybe<Array<RegistroCaptura>>;
  data_hora: Scalars['String']['output'];
  dispositivo?: Maybe<Dispositivo>;
  dispositivo_nanoid: Scalars['String']['output'];
  faixa?: Maybe<Faixa>;
  faixa_id: Scalars['Int']['output'];
  marca_desc: Scalars['String']['output'];
  modelo_desc: Scalars['String']['output'];
  nanoid: Scalars['String']['output'];
  programacao?: Maybe<Programacao>;
  programacao_nanoid?: Maybe<Scalars['String']['output']>;
  solicitacao?: Maybe<Solicitacao>;
  solicitacao_nanoid?: Maybe<Scalars['String']['output']>;
  tipo: Scalars['Int']['output'];
  usuario?: Maybe<Usuario>;
  usuario_nanoid: Scalars['String']['output'];
};

export type RegistroCaptura = {
  __typename?: 'RegistroCaptura';
  anexo?: Maybe<Scalars['String']['output']>;
  arquivo?: Maybe<Scalars['String']['output']>;
  ativo: Scalars['String']['output'];
  data_hora: Scalars['String']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  mime_type?: Maybe<Scalars['String']['output']>;
  motivo_ausencia?: Maybe<Scalars['String']['output']>;
  motivo_ausencia_obs?: Maybe<Scalars['String']['output']>;
  nanoid: Scalars['String']['output'];
  principal: Scalars['String']['output'];
  registro?: Maybe<Registro>;
  registro_nanoid: Scalars['String']['output'];
  tipo_captura?: Maybe<TipoCaptura>;
  tipo_captura_id?: Maybe<Scalars['Int']['output']>;
  usuario?: Maybe<Usuario>;
  usuario_nanoid: Scalars['String']['output'];
};

export type RegistroCapturaAnexoInput = {
  arquivo?: InputMaybe<Scalars['String']['input']>;
  mime_type?: InputMaybe<Scalars['String']['input']>;
};

export type RegistroCapturaDataTable = {
  __typename?: 'RegistroCapturaDataTable';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<RegistroCaptura>>;
};

export type RegistroCapturaFilterInput = {
  data_hora?: InputMaybe<PrimeFilterItemString>;
  principal?: InputMaybe<PrimeFilterItemString>;
  registro_nanoid?: InputMaybe<PrimeFilterItemString>;
  tipo_captura_id?: InputMaybe<PrimeFilterItemInt>;
  usuario_nanoid?: InputMaybe<PrimeFilterItemString>;
};

export type RegistroCapturaInput = {
  anexo?: InputMaybe<Array<RegistroCapturaAnexoInput>>;
  arquivo?: InputMaybe<Scalars['String']['input']>;
  ativo?: InputMaybe<Scalars['String']['input']>;
  data_hora?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  mime_type?: InputMaybe<Scalars['String']['input']>;
  motivo_ausencia?: InputMaybe<Scalars['String']['input']>;
  motivo_ausencia_obs?: InputMaybe<Scalars['String']['input']>;
  nanoid?: InputMaybe<Scalars['String']['input']>;
  principal?: InputMaybe<Scalars['String']['input']>;
  registro_nanoid?: InputMaybe<Scalars['String']['input']>;
  tipo_captura_id?: InputMaybe<Scalars['Int']['input']>;
  usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
};

export type RegistroCapturaListInput = {
  filters?: InputMaybe<RegistroCapturaFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type RegistroDataTable = {
  __typename?: 'RegistroDataTable';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Registro>>;
};

export type RegistroFilterInput = {
  ativo?: InputMaybe<PrimeFilterItemString>;
  contratos?: InputMaybe<PrimeFilterItemIntArray>;
  data_hora?: InputMaybe<PrimeFilterItemStringArray>;
  dispositivo_nanoid?: InputMaybe<PrimeFilterItemStringArray>;
  faixa_id?: InputMaybe<PrimeFilterItemIntArray>;
  marca_desc?: InputMaybe<PrimeFilterItemStringArray>;
  modelo_desc?: InputMaybe<PrimeFilterItemStringArray>;
  regionais?: InputMaybe<PrimeFilterItemIntArray>;
  tipo?: InputMaybe<PrimeFilterItemInt>;
  usuario_nanoid?: InputMaybe<PrimeFilterItemStringArray>;
};

export type RegistroInput = {
  ativo?: InputMaybe<Scalars['String']['input']>;
  capturas?: InputMaybe<Array<RegistroCapturaInput>>;
  data_hora?: InputMaybe<Scalars['String']['input']>;
  dispositivo_nanoid?: InputMaybe<Scalars['String']['input']>;
  faixa_id?: InputMaybe<Scalars['Int']['input']>;
  marca_desc?: InputMaybe<Scalars['String']['input']>;
  modelo_desc?: InputMaybe<Scalars['String']['input']>;
  nanoid?: InputMaybe<Scalars['String']['input']>;
  programacao_nanoid?: InputMaybe<Scalars['String']['input']>;
  solicitacao_nanoid?: InputMaybe<Scalars['String']['input']>;
  tipo?: InputMaybe<Scalars['Int']['input']>;
  usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
};

export type RegistroListInput = {
  filters?: InputMaybe<RegistroFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type RegistroSolicitacaoInput = {
  capturas: Array<RegistroCapturaInput>;
  registro_nanoid: Scalars['String']['input'];
};

export type RegistrosInput = {
  registros?: InputMaybe<Array<RegistroInput>>;
  solicitacoes?: InputMaybe<Array<SolicitacaoInput>>;
};

export type RelatorioFaixaInput = {
  ano: Scalars['Int']['input'];
  contrato_id: Scalars['Int']['input'];
  mes: Scalars['Int']['input'];
  quinzena?: InputMaybe<Scalars['Int']['input']>;
  regional_id?: InputMaybe<Scalars['Int']['input']>;
  tipo_registro_id?: InputMaybe<Scalars['Int']['input']>;
};

export type RelatorioExcelOutput = {
  __typename?: 'RelatorioExcelOutput';
  base64: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type RelatorioFaixaPdfInput = {
  ano: Scalars['Int']['input'];
  contrato_id: Scalars['Int']['input'];
  faixas?: InputMaybe<Array<Scalars['String']['input']>>;
  mes: Scalars['Int']['input'];
  modelo: Scalars['Int']['input'];
  proporcao?: InputMaybe<Scalars['Int']['input']>;
  quinzena?: InputMaybe<Scalars['Int']['input']>;
  regional_id?: InputMaybe<Scalars['Int']['input']>;
  tipo_registro_id?: InputMaybe<Scalars['Int']['input']>;
};

export type RelatorioPdfOutput = {
  __typename?: 'RelatorioPdfOutput';
  jobId: string;
};

export type RelatorioPdfStatusOutput = {
  __typename?: 'RelatorioPdfStatusOutput';
  status: Scalars['String']['output'];
  url?: Scalars['String']['output'] | null;
  fileName?: Scalars['String']['output'] | null;
  erro?: Scalars['String']['output'] | null;
};

export type Rota = {
  __typename?: 'Rota';
  ativo: Scalars['String']['output'];
  atualizacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  criacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  data_hora_criacao: Scalars['String']['output'];
  descricao: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  usuario_atualizacao?: Maybe<Usuario>;
  usuario_criacao?: Maybe<Usuario>;
};

export type RotaDataTable = {
  __typename?: 'RotaDataTable';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Rota>>;
};

export type RotaFilterInput = {
  ativo?: InputMaybe<PrimeFilterItemString>;
  data_hora_criacao?: InputMaybe<PrimeFilterItemString>;
  descricao?: InputMaybe<PrimeFilterItemString>;
};

export type RotaInput = {
  ativo?: InputMaybe<Scalars['String']['input']>;
  atualizacao_usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  criacao_usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  data_hora_criacao?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type RotaListInput = {
  filters?: InputMaybe<RotaFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type SignUrl = {
  __typename?: 'SignUrl';
  signed?: Maybe<Scalars['String']['output']>;
};

export type Sincronizacao = {
  __typename?: 'Sincronizacao';
  data_hora: Scalars['String']['output'];
  nome_tabela: Scalars['String']['output'];
};

export type SincronizacaoDataResponse = {
  __typename?: 'SincronizacaoDataResponse';
  descricao?: Maybe<Scalars['String']['output']>;
  dispositivo_nanoid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  identificador?: Maybe<Scalars['String']['output']>;
  private_key?: Maybe<Scalars['String']['output']>;
};

export type SincronizacaoDispositivoInput = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  forceRecreate?: InputMaybe<Scalars['Boolean']['input']>;
  identificador: Scalars['String']['input'];
};

export type Solicitacao = {
  __typename?: 'Solicitacao';
  ativo: Scalars['String']['output'];
  atualizacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  criacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  data_hora_criacao: Scalars['String']['output'];
  descricao: Scalars['String']['output'];
  dispositivo?: Maybe<Dispositivo>;
  dispositivo_nanoid?: Maybe<Scalars['String']['output']>;
  dispositivos?: Maybe<Array<Dispositivo>>;
  faixa?: Maybe<Faixa>;
  faixa_id: Scalars['Int']['output'];
  nanoid: Scalars['String']['output'];
  origem: Scalars['String']['output'];
  status: Scalars['String']['output'];
  usuario_atualizacao?: Maybe<Usuario>;
  usuario_criacao?: Maybe<Usuario>;
};

export type SolicitacaoDataTable = {
  __typename?: 'SolicitacaoDataTable';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Solicitacao>>;
};

export type SolicitacaoFilterInput = {
  ativo?: InputMaybe<PrimeFilterItemString>;
  data_hora_criacao?: InputMaybe<PrimeFilterItemString>;
  descricao?: InputMaybe<PrimeFilterItemString>;
  dispositivo_nanoid?: InputMaybe<PrimeFilterItemStringArray>;
  faixa_id?: InputMaybe<PrimeFilterItemIntArray>;
  origem?: InputMaybe<PrimeFilterItemString>;
  status?: InputMaybe<PrimeFilterItemString>;
};

export type SolicitacaoInput = {
  ativo?: InputMaybe<Scalars['String']['input']>;
  atualizacao_usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  criacao_usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  data_hora_criacao?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  dispositivo_nanoid?: InputMaybe<Scalars['String']['input']>;
  faixa_id?: InputMaybe<Scalars['Int']['input']>;
  faixas?: InputMaybe<Array<Scalars['Int']['input']>>;
  nanoid?: InputMaybe<Scalars['String']['input']>;
  origem?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type SolicitacaoListInput = {
  filters?: InputMaybe<SolicitacaoFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type SolicitacoesInput = {
  solicitacoes?: InputMaybe<Array<SolicitacaoInput>>;
};

export type TipoCaptura = {
  __typename?: 'TipoCaptura';
  ativo: Scalars['String']['output'];
  atualizacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  categoria: Scalars['Int']['output'];
  criacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  data_hora_criacao: Scalars['String']['output'];
  descricao: Scalars['String']['output'];
  faixas?: Maybe<Array<Faixa>>;
  id: Scalars['Int']['output'];
  ordem?: Maybe<Scalars['Int']['output']>;
  usuario_atualizacao?: Maybe<Usuario>;
  usuario_criacao?: Maybe<Usuario>;
};

export type TipoCapturaDataTable = {
  __typename?: 'TipoCapturaDataTable';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<TipoCaptura>>;
};

export type TipoCapturaFilterInput = {
  ativo?: InputMaybe<PrimeFilterItemString>;
  categoria?: InputMaybe<PrimeFilterItemInt>;
  data_hora_criacao?: InputMaybe<PrimeFilterItemString>;
  descricao?: InputMaybe<PrimeFilterItemString>;
};

export type TipoCapturaInput = {
  ativo?: InputMaybe<Scalars['String']['input']>;
  atualizacao_usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  categoria?: InputMaybe<Scalars['Float']['input']>;
  criacao_usuario_nanoid?: InputMaybe<Scalars['String']['input']>;
  data_hora_criacao?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ordem?: InputMaybe<Scalars['Float']['input']>;
};

export type TipoCapturaListInput = {
  filters?: InputMaybe<TipoCapturaFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type Usuario = {
  __typename?: 'Usuario';
  assinatura?: Maybe<Scalars['String']['output']>;
  ativo?: Maybe<Scalars['String']['output']>;
  atualizacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  criacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  data_hora_ativacao?: Maybe<Scalars['String']['output']>;
  data_hora_criacao?: Maybe<Scalars['String']['output']>;
  data_hora_desativacao?: Maybe<Scalars['String']['output']>;
  data_hora_expiracao?: Maybe<Scalars['String']['output']>;
  data_hora_ultima_atividade?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  foto?: Maybe<Scalars['String']['output']>;
  grupo_sistema?: Maybe<GrupoSistema>;
  grupo_sistema_id?: Maybe<Scalars['Int']['output']>;
  historico_acesso?: Maybe<Array<HistoricoAcesso>>;
  nanoid: Scalars['String']['output'];
  nome?: Maybe<Scalars['String']['output']>;
  permissoes?: Maybe<Array<Permissao>>;
  private_key?: Maybe<Scalars['String']['output']>;
  tipo?: Maybe<Scalars['Int']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  ultimo_acesso?: Maybe<Scalars['String']['output']>;
  ultimo_acesso_nanoid?: Maybe<Scalars['String']['output']>;
  ultimo_historico_acesso?: Maybe<HistoricoAcesso>;
  usuario: Scalars['String']['output'];
  usuario_atualizacao?: Maybe<Usuario>;
  usuario_criacao?: Maybe<Usuario>;
};

export type UsuarioAlterarSenhaInput = {
  nanoid: Scalars['String']['input'];
  novaSenha: Scalars['String']['input'];
  senhaAtual?: InputMaybe<Scalars['String']['input']>;
};

export type UsuarioDataTable = {
  __typename?: 'UsuarioDataTable';
  count?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Usuario>>;
};

export type UsuarioFilterInput = {
  ativo?: InputMaybe<PrimeFilterItemString>;
  email?: InputMaybe<PrimeFilterItemString>;
  nanoid?: InputMaybe<PrimeFilterItemString>;
  nome?: InputMaybe<PrimeFilterItemString>;
  tipo?: InputMaybe<PrimeFilterItemInt>;
  usuario?: InputMaybe<PrimeFilterItemString>;
};

export type UsuarioFullData = {
  __typename?: 'UsuarioFullData';
  assinatura?: Maybe<Scalars['String']['output']>;
  ativo?: Maybe<Scalars['String']['output']>;
  atualizacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  criacao_usuario_nanoid?: Maybe<Scalars['String']['output']>;
  data_hora_ativacao?: Maybe<Scalars['String']['output']>;
  data_hora_criacao?: Maybe<Scalars['String']['output']>;
  data_hora_desativacao?: Maybe<Scalars['String']['output']>;
  data_hora_expiracao?: Maybe<Scalars['String']['output']>;
  data_hora_ultima_atividade?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  foto?: Maybe<Scalars['String']['output']>;
  grupo_sistema?: Maybe<GrupoSistema>;
  grupo_sistema_id?: Maybe<Scalars['Int']['output']>;
  historico_acesso?: Maybe<Array<HistoricoAcesso>>;
  nanoid: Scalars['String']['output'];
  nome?: Maybe<Scalars['String']['output']>;
  permissoes?: Maybe<Array<Permissao>>;
  private_key?: Maybe<Scalars['String']['output']>;
  senha?: Maybe<Scalars['String']['output']>;
  tipo?: Maybe<Scalars['Int']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  ultimo_acesso?: Maybe<Scalars['String']['output']>;
  ultimo_acesso_nanoid?: Maybe<Scalars['String']['output']>;
  ultimo_historico_acesso?: Maybe<HistoricoAcesso>;
  usuario: Scalars['String']['output'];
  usuario_atualizacao?: Maybe<Usuario>;
  usuario_criacao?: Maybe<Usuario>;
};

export type UsuarioInput = {
  assinatura?: InputMaybe<Scalars['String']['input']>;
  ativo?: InputMaybe<Scalars['String']['input']>;
  data_hora_ativacao?: InputMaybe<Scalars['String']['input']>;
  data_hora_desativacao?: InputMaybe<Scalars['String']['input']>;
  data_hora_expiracao?: InputMaybe<Scalars['String']['input']>;
  data_hora_ultima_atividade?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  foto?: InputMaybe<Scalars['String']['input']>;
  grupo_sistema_id?: InputMaybe<Scalars['Int']['input']>;
  nanoid?: InputMaybe<Scalars['String']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  permissoes?: InputMaybe<Array<Scalars['String']['input']>>;
  regioes?: InputMaybe<Scalars['String']['input']>;
  senha?: InputMaybe<Scalars['String']['input']>;
  tipo?: InputMaybe<Scalars['Int']['input']>;
  ultimo_acesso?: InputMaybe<Scalars['String']['input']>;
  ultimo_acesso_nanoid?: InputMaybe<Scalars['String']['input']>;
  usuario?: InputMaybe<Scalars['String']['input']>;
};

export type UsuarioListInput = {
  filters?: InputMaybe<UsuarioFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
};

export type UsuarioLoginInput = {
  senha: Scalars['String']['input'];
  usuario: Scalars['String']['input'];
};

export type UsuariosInput = {
  usuarios?: InputMaybe<Array<UsuarioInput>>;
};

export type ZipFileInput = {
  ano?: InputMaybe<Scalars['Float']['input']>;
  contrato_id: Scalars['Float']['input'];
  faixasIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  mes?: InputMaybe<Scalars['Float']['input']>;
  num_serie?: InputMaybe<Scalars['String']['input']>;
  pathTags: Scalars['String']['input'];
  quinzena?: InputMaybe<Scalars['Float']['input']>;
};

export type FiltrarCidadeQueryVariables = Exact<{
  filter: CidadeListInput;
}>;

export type FiltrarCidadeQuery = {
  __typename?: 'Query';
  filtrarCidade?: {
    __typename?: 'CidadeDataTable';
    count?: number | null;
    rows?: Array<{
      __typename?: 'Cidade';
      id: number;
      nome: string;
      uf: string;
      codigo_ibge?: string | null;
      criacao_usuario_nanoid?: string | null;
      data_hora_criacao: string;
      ativo: string;
      usuario_criacao?: { __typename?: 'Usuario'; nome?: string | null } | null;
    }> | null;
  } | null;
};

export type BuscarCidadePorIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type BuscarCidadePorIdQuery = {
  __typename?: 'Query';
  buscarCidadePorId?: {
    __typename?: 'Cidade';
    id: number;
    nome: string;
    uf: string;
    codigo_ibge?: string | null;
    criacao_usuario_nanoid?: string | null;
    atualizacao_usuario_nanoid?: string | null;
    data_hora_criacao: string;
    ativo: string;
  } | null;
};

export type ListarCidadeQueryVariables = Exact<{ [key: string]: never }>;

export type ListarCidadeQuery = {
  __typename?: 'Query';
  listarCidade?: Array<{
    __typename?: 'Cidade';
    id: number;
    nome: string;
  }> | null;
};

export type CriarAlterarCidadeMutationVariables = Exact<{
  data: CidadeInput;
}>;

export type CriarAlterarCidadeMutation = {
  __typename?: 'Mutation';
  criarAlterarCidade?: { __typename?: 'Cidade'; id: number } | null;
};

export type FiltrarContratoQueryVariables = Exact<{
  filter: ContratoListInput;
}>;

export type FiltrarContratoQuery = {
  __typename?: 'Query';
  filtrarContrato?: {
    __typename?: 'ContratoDataTable';
    count?: number | null;
    rows?: Array<{
      __typename?: 'Contrato';
      id: number;
      cidade_id: number;
      descricao: string;
      endereco?: string | null;
      periodicidade: string;
      codigo_contrato: string;
      criacao_usuario_nanoid?: string | null;
      atualizacao_usuario_nanoid?: string | null;
      data_hora_criacao: string;
      ativo: string;
      usuario_criacao?: { __typename?: 'Usuario'; nome?: string | null } | null;
      cidade?: { __typename?: 'Cidade'; nome: string } | null;
    }> | null;
  } | null;
};

export type BuscarContratoPorIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type BuscarContratoPorIdQuery = {
  __typename?: 'Query';
  buscarContratoPorId?: {
    __typename?: 'Contrato';
    id: number;
    cidade_id: number;
    descricao: string;
    endereco?: string | null;
    periodicidade: string;
    codigo_contrato: string;
    rel_exibir_data?: string | null;
    rel_exibir_coordenada?: string | null;
    rel_exibir_cidade?: string | null;
    path_tags?: string | null;
    criacao_usuario_nanoid?: string | null;
    atualizacao_usuario_nanoid?: string | null;
    data_hora_criacao: string;
    ativo: string;
  } | null;
};

export type ListarContratoQueryVariables = Exact<{ [key: string]: never }>;

export type ListarContratoQuery = {
  __typename?: 'Query';
  listarContrato?: Array<{
    __typename?: 'Contrato';
    id: number;
    descricao: string;
    periodicidade: string;
    rel_exibir_data?: string | null;
    rel_exibir_coordenada?: string | null;
    rel_exibir_cidade?: string | null;
    path_tags?: string | null;
  }> | null;
};

export type CriarAlterarContratoMutationVariables = Exact<{
  data: ContratoInput;
}>;

export type CriarAlterarContratoMutation = {
  __typename?: 'Mutation';
  criarAlterarContrato?: { __typename?: 'Contrato'; id: number } | null;
};

export type FiltrarContratoZipQueryVariables = Exact<{
  filter: ContratoZipListInput;
}>;

export type FiltrarContratoZipQuery = {
  __typename?: 'Query';
  filtrarContratoZip?: {
    __typename?: 'ContratoZipDataTable';
    count?: number | null;
    rows?: Array<{
      __typename?: 'ContratoZip';
      nanoid: string;
      arquivo?: string | null;
      tamanho_mb?: number | null;
      descricao?: string | null;
      status: number;
      mensagem_erro?: string | null;
      data_hora_criacao: string;
      data_hora_finalizacao?: string | null;
      usuario_criacao?: { __typename?: 'Usuario'; nome?: string | null } | null;
      contrato?: { __typename?: 'Contrato'; descricao: string } | null;
    }> | null;
  } | null;
};

export type GerarZipContratoMutationVariables = Exact<{
  data: ZipFileInput;
}>;

export type GerarZipContratoMutation = {
  __typename?: 'Mutation';
  gerarZipContrato?: string | null;
};

export type CriarAlterarContratoZipMutationVariables = Exact<{
  data: ContratoZipInput;
}>;

export type CriarAlterarContratoZipMutation = {
  __typename?: 'Mutation';
  criarAlterarContratoZip?: {
    __typename?: 'ContratoZip';
    nanoid: string;
  } | null;
};

export type FiltrarDashboardQueryVariables = Exact<{
  ano: Scalars['Int']['input'];
  mes: Scalars['Int']['input'];
}>;

export type FiltrarDashboardQuery = {
  __typename?: 'Query';
  filtrarDashboard: {
    __typename?: 'DashboardData';
    numContratos: number;
    numFaixas: number;
    numRegistros: number;
    numSolicitacoesPendentes: number;
    numSolicitacoesFinalizadas: number;
    numProgramacoesExecutadas: number;
    numProgramacoesPendentes: number;
  };
};

export type FiltrarDispositivoQueryVariables = Exact<{
  filter: DispositivoListInput;
}>;

export type FiltrarDispositivoQuery = {
  __typename?: 'Query';
  filtrarDispositivo?: {
    __typename?: 'DispositivoDataTable';
    count?: number | null;
    rows?: Array<{
      __typename?: 'Dispositivo';
      nanoid: string;
      identificador?: string | null;
      descricao?: string | null;
      so?: string | null;
      data_hora_criacao?: string | null;
      data_hora_atualizacao?: string | null;
      ativo?: string | null;
      criacao_usuario_nanoid?: string | null;
      atualizacao_usuario_nanoid?: string | null;
      data_ultima_sincronia?: string | null;
    }> | null;
  } | null;
};

export type BuscarDispositivoPorIdQueryVariables = Exact<{
  nanoid: Scalars['String']['input'];
}>;

export type BuscarDispositivoPorIdQuery = {
  __typename?: 'Query';
  buscarDispositivoPorId?: {
    __typename?: 'Dispositivo';
    nanoid: string;
    identificador?: string | null;
    descricao?: string | null;
    so?: string | null;
    data_hora_criacao?: string | null;
    data_hora_atualizacao?: string | null;
    ativo?: string | null;
  } | null;
};

export type ListarDispositivosQueryVariables = Exact<{ [key: string]: never }>;

export type ListarDispositivosQuery = {
  __typename?: 'Query';
  listarDispositivos?: Array<{
    __typename?: 'Dispositivo';
    nanoid: string;
    descricao?: string | null;
  }> | null;
};

export type ListarDispositivosAtivosQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ListarDispositivosAtivosQuery = {
  __typename?: 'Query';
  listarDispositivosAtivos?: Array<{
    __typename?: 'Dispositivo';
    nanoid: string;
    identificador?: string | null;
    descricao?: string | null;
    so?: string | null;
  }> | null;
};

export type ListarUsuariosLogadosPorDispositivoQueryVariables = Exact<{
  dispositivoNanoid: Scalars['String']['input'];
}>;

export type ListarUsuariosLogadosPorDispositivoQuery = {
  __typename?: 'Query';
  listarUsuariosLogadosPorDispositivo?: Array<{
    __typename?: 'HistoricoAcesso';
    nanoid: string;
    status: string;
    data_hora_entrada?: string | null;
    usuario?: {
      __typename?: 'Usuario';
      nome?: string | null;
      usuario: string;
    } | null;
  }> | null;
};

export type SolicitarLogoutNoDispositivoMutationVariables = Exact<{
  historicoNanoid: Scalars['String']['input'];
}>;

export type SolicitarLogoutNoDispositivoMutation = {
  __typename?: 'Mutation';
  solicitarLogoutNoDispositivo?: {
    __typename?: 'HistoricoAcesso';
    nanoid: string;
  } | null;
};

export type CriarAlterarDispositivoMutationVariables = Exact<{
  data: DispositivoInput;
}>;

export type CriarAlterarDispositivoMutation = {
  __typename?: 'Mutation';
  criarAlterarDispositivo?: {
    __typename?: 'Dispositivo';
    nanoid: string;
  } | null;
};

export type AtivarDesativarDispositivosMutationVariables = Exact<{
  data: DispositivosInput;
}>;

export type AtivarDesativarDispositivosMutation = {
  __typename?: 'Mutation';
  ativarDesativarDispositivos?: Array<{
    __typename?: 'Dispositivo';
    nanoid: string;
  }> | null;
};

export type BuscarDispositivoKeyPorDispositivoQueryVariables = Exact<{
  nanoid: Scalars['String']['input'];
}>;

export type BuscarDispositivoKeyPorDispositivoQuery = {
  __typename?: 'Query';
  buscarDispositivoKeyPorDispositivo?: {
    __typename?: 'DispositivoKey';
    id: number;
    revogado?: string | null;
    data_hora_revogacao?: string | null;
  } | null;
};

export type CriarAlterarDispositivoKeyMutationVariables = Exact<{
  data: DispositivoKeyInput;
}>;

export type CriarAlterarDispositivoKeyMutation = {
  __typename?: 'Mutation';
  criarAlterarDispositivoKey?: {
    __typename?: 'DispositivoKey';
    id: number;
  } | null;
};

export type FiltrarEventoSiteQueryVariables = Exact<{
  filter: EventoListInput;
}>;

export type FiltrarEventoSiteQuery = {
  __typename?: 'Query';
  filtrarEventoSite?: Array<{
    __typename?: 'Evento';
    nanoid: string;
    descricao: string;
    tipo_evento: number;
    data_hora_criacao: string;
    usuario?: { __typename?: 'Usuario'; nome?: string | null } | null;
  }> | null;
};

export type FiltrarEventoDispositivoQueryVariables = Exact<{
  filter: EventoListInput;
}>;

export type FiltrarEventoDispositivoQuery = {
  __typename?: 'Query';
  filtrarEventoDispositivo?: Array<{
    __typename?: 'Evento';
    nanoid: string;
    descricao: string;
    tipo_evento: number;
    data_hora_criacao: string;
    usuario?: { __typename?: 'Usuario'; nome?: string | null } | null;
    dispositivo?: {
      __typename?: 'Dispositivo';
      descricao?: string | null;
    } | null;
  }> | null;
};

export type BuscarEventoSitePorIdQueryVariables = Exact<{
  nanoid: Scalars['String']['input'];
}>;

export type BuscarEventoSitePorIdQuery = {
  __typename?: 'Query';
  buscarEventoSitePorId?: {
    __typename?: 'Evento';
    nanoid: string;
    descricao: string;
    valores_antigos?: string | null;
    valores_novos?: string | null;
    tipo_evento: number;
    data_hora_criacao: string;
    usuario?: { __typename?: 'Usuario'; nome?: string | null } | null;
  } | null;
};

export type BuscarEventoDispositivoPorIdQueryVariables = Exact<{
  nanoid: Scalars['String']['input'];
}>;

export type BuscarEventoDispositivoPorIdQuery = {
  __typename?: 'Query';
  buscarEventoDispositivoPorId?: {
    __typename?: 'Evento';
    nanoid: string;
    descricao: string;
    valores_antigos?: string | null;
    valores_novos?: string | null;
    tipo_evento: number;
    data_hora_criacao: string;
    usuario?: { __typename?: 'Usuario'; nome?: string | null } | null;
    dispositivo?: {
      __typename?: 'Dispositivo';
      descricao?: string | null;
    } | null;
  } | null;
};

export type FiltrarFaixaQueryVariables = Exact<{
  filter: FaixaListInput;
}>;

export type FiltrarFaixaQuery = {
  __typename?: 'Query';
  filtrarFaixa?: {
    __typename?: 'FaixaDataTable';
    count?: number | null;
    rows?: Array<{
      __typename?: 'Faixa';
      id: number;
      modelo_id: number;
      contrato_id: number;
      regional_id: number;
      rota_id: number;
      local: string;
      identificacao: string;
      sentido: string;
      latitude?: string | null;
      longitude?: string | null;
      num_serie: string;
      codigo_cliente?: string | null;
      lote?: string | null;
      cod_dnit?: string | null;
      cod_grin?: string | null;
      tipo: number;
      data_inicio_operacao: string;
      data_venc_afericao?: string | null;
      data_venc_estudo_tec?: string | null;
      criacao_usuario_nanoid?: string | null;
      atualizacao_usuario_nanoid?: string | null;
      data_hora_criacao: string;
      ativo: string;
      usuario_criacao?: { __typename?: 'Usuario'; nome?: string | null } | null;
      modelo?: {
        __typename?: 'Modelo';
        descricao: string;
        marca?: { __typename?: 'Marca'; descricao: string } | null;
      } | null;
      contrato?: { __typename?: 'Contrato'; descricao: string } | null;
      regional?: { __typename?: 'Regional'; descricao: string } | null;
      rota?: { __typename?: 'Rota'; descricao: string } | null;
      cidade?: { __typename?: 'Cidade'; nome: string } | null;
    }> | null;
  } | null;
};

export type BuscarFaixaPorIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type BuscarFaixaPorIdQuery = {
  __typename?: 'Query';
  buscarFaixaPorId?: {
    __typename?: 'Faixa';
    id: number;
    modelo_id: number;
    contrato_id: number;
    regional_id: number;
    rota_id: number;
    cidade_id?: number | null;
    local: string;
    identificacao: string;
    sentido: string;
    latitude?: string | null;
    longitude?: string | null;
    num_serie: string;
    codigo_cliente?: string | null;
    lote?: string | null;
    cod_dnit?: string | null;
    cod_grin?: string | null;
    tipo: number;
    data_inicio_operacao: string;
    data_venc_afericao?: string | null;
    data_venc_estudo_tec?: string | null;
    criacao_usuario_nanoid?: string | null;
    atualizacao_usuario_nanoid?: string | null;
    data_hora_criacao: string;
    ativo: string;
    tipo_capturas?: Array<{ __typename?: 'TipoCaptura'; id: number }> | null;
    FaixaTipoCapturas?: Array<{
      __typename?: 'FaixaTipoCaptura';
      tipo_captura_id: number;
      replicar_de_faixa_id?: number | null;
    }> | null;
  } | null;
};

export type ListarFaixaQueryVariables = Exact<{ [key: string]: never }>;

export type ListarFaixaQuery = {
  __typename?: 'Query';
  listarFaixa?: Array<{
    __typename?: 'Faixa';
    id: number;
    identificacao: string;
    num_serie: string;
    codigo_cliente?: string | null;
    contrato?: { __typename?: 'Contrato'; descricao: string } | null;
    regional?: { __typename?: 'Regional'; descricao: string } | null;
  }> | null;
};

export type ListarFaixaAtivoQueryVariables = Exact<{ [key: string]: never }>;

export type ListarFaixaAtivoQuery = {
  __typename?: 'Query';
  listarFaixaAtivo?: Array<{
    __typename?: 'Faixa';
    id: number;
    identificacao: string;
    num_serie: string;
    codigo_cliente?: string | null;
    contrato?: { __typename?: 'Contrato'; descricao: string } | null;
    regional?: { __typename?: 'Regional'; descricao: string } | null;
  }> | null;
};

export type CriarAlterarFaixaMutationVariables = Exact<{
  data: FaixaInput;
}>;

export type CriarAlterarFaixaMutation = {
  __typename?: 'Mutation';
  criarAlterarFaixa?: { __typename?: 'Faixa'; id: number } | null;
};

export type FiltrarGrupoSistemaQueryVariables = Exact<{
  filter: GrupoSistemaListInput;
}>;

export type FiltrarGrupoSistemaQuery = {
  __typename?: 'Query';
  filtrarGrupoSistema?: {
    __typename?: 'GrupoSistemaDataTable';
    count?: number | null;
    rows?: Array<{
      __typename?: 'GrupoSistema';
      id: number;
      nome: string;
      descricao?: string | null;
    }> | null;
  } | null;
};

export type ListarGrupoSistemaQueryVariables = Exact<{ [key: string]: never }>;

export type ListarGrupoSistemaQuery = {
  __typename?: 'Query';
  listarGrupoSistema?: Array<{
    __typename?: 'GrupoSistema';
    id: number;
    nome: string;
    descricao?: string | null;
    permissoes?: Array<{
      __typename?: 'Permissao';
      nanoid: string;
      descricao: string;
      categoria: string;
      ativo: string;
    }> | null;
  }> | null;
};

export type BuscarGrupoSistemaPorIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type BuscarGrupoSistemaPorIdQuery = {
  __typename?: 'Query';
  buscarGrupoSistemaPorId?: {
    __typename?: 'GrupoSistema';
    id: number;
    nome: string;
    descricao?: string | null;
    permissoes?: Array<{ __typename?: 'Permissao'; nanoid: string }> | null;
  } | null;
};

export type CriarAlterarGrupoSistemaMutationVariables = Exact<{
  data: GrupoSistemaInput;
}>;

export type CriarAlterarGrupoSistemaMutation = {
  __typename?: 'Mutation';
  criarAlterarGrupoSistema?: { __typename?: 'GrupoSistema'; id: number } | null;
};

export type FiltrarHistoricoAcessoQueryVariables = Exact<{
  filter: HistoricoAcessoListInput;
}>;

export type FiltrarHistoricoAcessoQuery = {
  __typename?: 'Query';
  filtrarHistoricoAcesso?: {
    __typename?: 'HistoricoAcessoDataTable';
    count?: number | null;
    rows?: Array<{
      __typename?: 'HistoricoAcesso';
      nanoid: string;
      data_hora_entrada?: string | null;
      data_hora_saida?: string | null;
      dispositivo?: {
        __typename?: 'Dispositivo';
        descricao?: string | null;
        identificador?: string | null;
      } | null;
      usuario?: {
        __typename?: 'Usuario';
        nome?: string | null;
        usuario: string;
      } | null;
    }> | null;
  } | null;
};

export type BuscarHistoricoAcessoPorIdQueryVariables = Exact<{
  nanoid: Scalars['String']['input'];
}>;

export type BuscarHistoricoAcessoPorIdQuery = {
  __typename?: 'Query';
  buscarHistoricoAcessoPorId?: {
    __typename?: 'HistoricoAcesso';
    nanoid: string;
    data_hora_entrada?: string | null;
    data_hora_saida?: string | null;
    usuario?: {
      __typename?: 'Usuario';
      nome?: string | null;
      usuario: string;
    } | null;
    dispositivo?: {
      __typename?: 'Dispositivo';
      descricao?: string | null;
      identificador?: string | null;
    } | null;
  } | null;
};

export type ImportCsvMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  modelName: Scalars['String']['input'];
}>;

export type ImportCsvMutation = {
  __typename?: 'Mutation';
  importCsv?: {
    __typename?: 'ImportInfo';
    modelName: string;
    created?: number | null;
    updated?: number | null;
    canCreate?: boolean | null;
    canUpdate?: boolean | null;
  } | null;
};

export type FiltrarMarcaQueryVariables = Exact<{
  filter: MarcaListInput;
}>;

export type FiltrarMarcaQuery = {
  __typename?: 'Query';
  filtrarMarca?: {
    __typename?: 'MarcaDataTable';
    count?: number | null;
    rows?: Array<{
      __typename?: 'Marca';
      id: number;
      descricao: string;
      criacao_usuario_nanoid?: string | null;
      data_hora_criacao: string;
      ativo: string;
      usuario_criacao?: { __typename?: 'Usuario'; nome?: string | null } | null;
    }> | null;
  } | null;
};

export type BuscarMarcaPorIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type BuscarMarcaPorIdQuery = {
  __typename?: 'Query';
  buscarMarcaPorId?: {
    __typename?: 'Marca';
    id: number;
    descricao: string;
    criacao_usuario_nanoid?: string | null;
    atualizacao_usuario_nanoid?: string | null;
    data_hora_criacao: string;
    ativo: string;
  } | null;
};

export type ListarMarcaQueryVariables = Exact<{ [key: string]: never }>;

export type ListarMarcaQuery = {
  __typename?: 'Query';
  listarMarca?: Array<{
    __typename?: 'Marca';
    id: number;
    descricao: string;
  }> | null;
};

export type CriarAlterarMarcaMutationVariables = Exact<{
  data: MarcaInput;
}>;

export type CriarAlterarMarcaMutation = {
  __typename?: 'Mutation';
  criarAlterarMarca?: { __typename?: 'Marca'; id: number } | null;
};

export type FiltrarModeloQueryVariables = Exact<{
  filter: ModeloListInput;
}>;

export type FiltrarModeloQuery = {
  __typename?: 'Query';
  filtrarModelo?: {
    __typename?: 'ModeloDataTable';
    count?: number | null;
    rows?: Array<{
      __typename?: 'Modelo';
      id: number;
      descricao: string;
      criacao_usuario_nanoid?: string | null;
      data_hora_criacao: string;
      ativo: string;
      usuario_criacao?: { __typename?: 'Usuario'; nome?: string | null } | null;
      marca?: { __typename?: 'Marca'; descricao: string } | null;
    }> | null;
  } | null;
};

export type BuscarModeloPorIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type BuscarModeloPorIdQuery = {
  __typename?: 'Query';
  buscarModeloPorId?: {
    __typename?: 'Modelo';
    id: number;
    descricao: string;
    marca_id: number;
    criacao_usuario_nanoid?: string | null;
    atualizacao_usuario_nanoid?: string | null;
    data_hora_criacao: string;
    ativo: string;
  } | null;
};

export type ListarModeloQueryVariables = Exact<{ [key: string]: never }>;

export type ListarModeloQuery = {
  __typename?: 'Query';
  listarModelo?: Array<{
    __typename?: 'Modelo';
    id: number;
    descricao: string;
  }> | null;
};

export type CriarAlterarModeloMutationVariables = Exact<{
  data: ModeloInput;
}>;

export type CriarAlterarModeloMutation = {
  __typename?: 'Mutation';
  criarAlterarModelo?: { __typename?: 'Modelo'; id: number } | null;
};

export type FiltrarMotivoAusenciaQueryVariables = Exact<{
  filter: MotivoAusenciaListInput;
}>;

export type FiltrarMotivoAusenciaQuery = {
  __typename?: 'Query';
  filtrarMotivoAusencia?: {
    __typename?: 'MotivoAusenciaDataTable';
    count?: number | null;
    rows?: Array<{
      __typename?: 'MotivoAusencia';
      nanoid: string;
      descricao: string;
      criacao_usuario_nanoid?: string | null;
      data_hora_criacao: string;
      ativo: string;
      usuario_criacao?: { __typename?: 'Usuario'; nome?: string | null } | null;
    }> | null;
  } | null;
};

export type BuscarMotivoAusenciaPorIdQueryVariables = Exact<{
  nanoid: Scalars['String']['input'];
}>;

export type BuscarMotivoAusenciaPorIdQuery = {
  __typename?: 'Query';
  buscarMotivoAusenciaPorId?: {
    __typename?: 'MotivoAusencia';
    nanoid: string;
    descricao: string;
    criacao_usuario_nanoid?: string | null;
    atualizacao_usuario_nanoid?: string | null;
    data_hora_criacao: string;
    ativo: string;
  } | null;
};

export type ListarMotivoAusenciaQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ListarMotivoAusenciaQuery = {
  __typename?: 'Query';
  listarMotivoAusencia?: Array<{
    __typename?: 'MotivoAusencia';
    nanoid: string;
    descricao: string;
  }> | null;
};

export type CriarAlterarMotivoAusenciaMutationVariables = Exact<{
  data: MotivoAusenciaInput;
}>;

export type CriarAlterarMotivoAusenciaMutation = {
  __typename?: 'Mutation';
  criarAlterarMotivoAusencia?: {
    __typename?: 'MotivoAusencia';
    nanoid: string;
  } | null;
};

export type FiltrarParametroQueryVariables = Exact<{
  filter: ParametroListInput;
}>;

export type FiltrarParametroQuery = {
  __typename?: 'Query';
  filtrarParametro?: {
    __typename?: 'ParametroDataTable';
    count?: number | null;
    rows?: Array<{
      __typename?: 'Parametro';
      id: number;
      tipo: string;
      valor?: string | null;
      tipo_valor?: string | null;
      descricao?: string | null;
      grupo?: string | null;
      data_hora_criacao?: string | null;
    }> | null;
  } | null;
};

export type BuscarParametroPorIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type BuscarParametroPorIdQuery = {
  __typename?: 'Query';
  buscarParametroPorId?: {
    __typename?: 'Parametro';
    id: number;
    tipo: string;
    valor?: string | null;
    tipo_valor?: string | null;
    descricao?: string | null;
    grupo?: string | null;
    data_hora_criacao?: string | null;
  } | null;
};

export type BuscarParametroPorTipoQueryVariables = Exact<{
  tipo: Scalars['String']['input'];
}>;

export type BuscarParametroPorTipoQuery = {
  __typename?: 'Query';
  buscarParametroPorTipo?: {
    __typename?: 'Parametro';
    id: number;
    tipo: string;
    valor?: string | null;
    tipo_valor?: string | null;
    descricao?: string | null;
    grupo?: string | null;
    data_hora_criacao?: string | null;
  } | null;
};

export type ListarParametroPorTipoQueryVariables = Exact<{
  tipos: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type ListarParametroPorTipoQuery = {
  __typename?: 'Query';
  listarParametroPorTipo?: Array<{
    __typename?: 'Parametro';
    id: number;
    tipo: string;
    valor?: string | null;
    tipo_valor?: string | null;
    descricao?: string | null;
    grupo?: string | null;
    data_hora_criacao?: string | null;
  }> | null;
};

export type BuscarGrupoQueryVariables = Exact<{ [key: string]: never }>;

export type BuscarGrupoQuery = {
  __typename?: 'Query';
  buscarGrupo?: Array<{
    __typename?: 'Parametro';
    grupo?: string | null;
  }> | null;
};

export type ListarParametroQueryVariables = Exact<{ [key: string]: never }>;

export type ListarParametroQuery = {
  __typename?: 'Query';
  listarParametro?: Array<{
    __typename?: 'Parametro';
    id: number;
    tipo: string;
    valor?: string | null;
    tipo_valor?: string | null;
    descricao?: string | null;
    grupo?: string | null;
    data_hora_criacao?: string | null;
  }> | null;
};

export type CriarAlterarParametroMutationVariables = Exact<{
  data: ParametroInput;
}>;

export type CriarAlterarParametroMutation = {
  __typename?: 'Mutation';
  criarAlterarParametro?: { __typename?: 'Parametro'; id: number } | null;
};

export type ListarPermissoesQueryVariables = Exact<{ [key: string]: never }>;

export type ListarPermissoesQuery = {
  __typename?: 'Query';
  listarPermissoes?: Array<{
    __typename?: 'Permissao';
    nanoid: string;
    descricao: string;
    categoria: string;
    ativo: string;
  }> | null;
};

export type FiltrarProgramacaoQueryVariables = Exact<{
  filter: ProgramacaoListInput;
}>;

export type FiltrarProgramacaoQuery = {
  __typename?: 'Query';
  filtrarProgramacao?: {
    __typename?: 'ProgramacaoDataTable';
    count?: number | null;
    rows?: Array<{
      __typename?: 'Programacao';
      nanoid: string;
      contrato_id: number;
      faixa_id: number;
      mes?: number | null;
      ano?: number | null;
      periodicidade: string;
      quinzena?: number | null;
      executado: string;
      motivo_ausencia?: string | null;
      motivo_ausencia_obs?: string | null;
      usuario_execucao_nanoid?: string | null;
      data_hora_execucao?: string | null;
      data_hora_criacao: string;
      ativo: string;
      sincronizado: string;
      contrato?: { __typename?: 'Contrato'; descricao: string } | null;
      faixa?: { __typename?: 'Faixa'; identificacao: string } | null;
    }> | null;
  } | null;
};

export type BuscarProgramacaoPorIdQueryVariables = Exact<{
  nanoid: Scalars['String']['input'];
}>;

export type BuscarProgramacaoPorIdQuery = {
  __typename?: 'Query';
  buscarProgramacaoPorId?: {
    __typename?: 'Programacao';
    nanoid: string;
    contrato_id: number;
    faixa_id: number;
    mes?: number | null;
    ano?: number | null;
    periodicidade: string;
    quinzena?: number | null;
    executado: string;
    motivo_ausencia?: string | null;
    motivo_ausencia_obs?: string | null;
    usuario_execucao_nanoid?: string | null;
    data_hora_execucao?: string | null;
    data_hora_criacao: string;
    ativo: string;
    sincronizado: string;
  } | null;
};

export type GerarProgramacaoQueryVariables = Exact<{ [key: string]: never }>;

export type GerarProgramacaoQuery = {
  __typename?: 'Query';
  gerarProgramacao?: Array<{
    __typename?: 'Programacao';
    nanoid: string;
  }> | null;
};

export type CriarAlterarProgramacaoMutationVariables = Exact<{
  data: ProgramacaoInput;
}>;

export type CriarAlterarProgramacaoMutation = {
  __typename?: 'Mutation';
  criarAlterarProgramacao?: {
    __typename?: 'Programacao';
    nanoid: string;
  } | null;
};

export type FiltrarRegionalQueryVariables = Exact<{
  filter: RegionalListInput;
}>;

export type FiltrarRegionalQuery = {
  __typename?: 'Query';
  filtrarRegional?: {
    __typename?: 'RegionalDataTable';
    count?: number | null;
    rows?: Array<{
      __typename?: 'Regional';
      id: number;
      descricao: string;
      criacao_usuario_nanoid?: string | null;
      data_hora_criacao: string;
      ativo: string;
      usuario_criacao?: { __typename?: 'Usuario'; nome?: string | null } | null;
    }> | null;
  } | null;
};

export type BuscarRegionalPorIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type BuscarRegionalPorIdQuery = {
  __typename?: 'Query';
  buscarRegionalPorId?: {
    __typename?: 'Regional';
    id: number;
    descricao: string;
    criacao_usuario_nanoid?: string | null;
    atualizacao_usuario_nanoid?: string | null;
    data_hora_criacao: string;
    ativo: string;
  } | null;
};

export type ListarRegionalQueryVariables = Exact<{ [key: string]: never }>;

export type ListarRegionalQuery = {
  __typename?: 'Query';
  listarRegional?: Array<{
    __typename?: 'Regional';
    id: number;
    descricao: string;
  }> | null;
};

export type CriarAlterarRegionalMutationVariables = Exact<{
  data: RegionalInput;
}>;

export type CriarAlterarRegionalMutation = {
  __typename?: 'Mutation';
  criarAlterarRegional?: { __typename?: 'Regional'; id: number } | null;
};

export type FiltrarRegistroQueryVariables = Exact<{
  filter: RegistroListInput;
}>;

export type FiltrarRegistroQuery = {
  __typename?: 'Query';
  filtrarRegistro?: {
    __typename?: 'RegistroDataTable';
    count?: number | null;
    rows?: Array<{
      __typename?: 'Registro';
      nanoid: string;
      faixa_id: number;
      usuario_nanoid: string;
      dispositivo_nanoid: string;
      data_hora: string;
      modelo_desc: string;
      marca_desc: string;
      ativo: string;
      tipo: number;
      usuario?: { __typename?: 'Usuario'; nome?: string | null } | null;
      dispositivo?: {
        __typename?: 'Dispositivo';
        descricao?: string | null;
      } | null;
      solicitacao?: { __typename?: 'Solicitacao'; descricao: string } | null;
      programacao?: {
        __typename?: 'Programacao';
        ano?: number | null;
        mes?: number | null;
        quinzena?: number | null;
      } | null;
      faixa?: {
        __typename?: 'Faixa';
        identificacao: string;
        sentido: string;
        contrato?: { __typename?: 'Contrato'; descricao: string } | null;
        regional?: { __typename?: 'Regional'; descricao: string } | null;
      } | null;
    }> | null;
  } | null;
};

export type BuscarRegistroPorIdQueryVariables = Exact<{
  nanoid: Scalars['String']['input'];
}>;

export type BuscarRegistroPorIdQuery = {
  __typename?: 'Query';
  buscarRegistroPorId?: {
    __typename?: 'Registro';
    nanoid: string;
    faixa_id: number;
    solicitacao_nanoid?: string | null;
    programacao_nanoid?: string | null;
    usuario_nanoid: string;
    dispositivo_nanoid: string;
    data_hora: string;
    modelo_desc: string;
    marca_desc: string;
    ativo: string;
    tipo: number;
    faixa?: {
      __typename?: 'Faixa';
      identificacao: string;
      num_serie: string;
      sentido: string;
      contrato?: { __typename?: 'Contrato'; descricao: string } | null;
      tipo_capturas?: Array<{
        __typename?: 'TipoCaptura';
        id: number;
        descricao: string;
      }> | null;
      cidade?: { __typename?: 'Cidade'; nome: string } | null;
    } | null;
    capturas?: Array<{
      __typename?: 'RegistroCaptura';
      nanoid: string;
      tipo_captura_id?: number | null;
      data_hora: string;
      latitude?: string | null;
      longitude?: string | null;
      arquivo?: string | null;
      mime_type?: string | null;
      motivo_ausencia?: string | null;
      motivo_ausencia_obs?: string | null;
      principal: string;
      ativo: string;
      anexo?: string | null;
      tipo_captura?: { __typename?: 'TipoCaptura'; descricao: string } | null;
    }> | null;
  } | null;
};

export type ListarRegistroPorSolicitacaoQueryVariables = Exact<{
  solicitacaoNanoid: Scalars['String']['input'];
}>;

export type ListarRegistroPorSolicitacaoQuery = {
  __typename?: 'Query';
  listarRegistroPorSolicitacao?: Array<{
    __typename?: 'Registro';
    nanoid: string;
    faixa?: {
      __typename?: 'Faixa';
      tipo_capturas?: Array<{
        __typename?: 'TipoCaptura';
        id: number;
        descricao: string;
      }> | null;
    } | null;
    capturas?: Array<{
      __typename?: 'RegistroCaptura';
      nanoid: string;
      arquivo?: string | null;
      tipo_captura_id?: number | null;
      tipo_captura?: {
        __typename?: 'TipoCaptura';
        id: number;
        descricao: string;
      } | null;
    }> | null;
  }> | null;
};

export type CriarAlterarRegistroMutationVariables = Exact<{
  data: RegistroInput;
}>;

export type CriarAlterarRegistroMutation = {
  __typename?: 'Mutation';
  criarAlterarRegistro?: { __typename?: 'Registro'; nanoid: string } | null;
};

export type CriarAlterarRegistroCapturaMutationVariables = Exact<{
  data: RegistroCapturaInput;
}>;

export type CriarAlterarRegistroCapturaMutation = {
  __typename?: 'Mutation';
  criarAlterarRegistroCaptura?: {
    __typename?: 'RegistroCaptura';
    nanoid: string;
  } | null;
};

export type IncluirCapturasNoRegistroMutationVariables = Exact<{
  data: RegistroSolicitacaoInput;
}>;

export type IncluirCapturasNoRegistroMutation = {
  __typename?: 'Mutation';
  incluirCapturasNoRegistro?: Array<{
    __typename?: 'RegistroCaptura';
    nanoid: string;
  }> | null;
};

export type FiltrarRelatorioFaixaQueryVariables = Exact<{
  filter: RelatorioFaixaInput;
}>;

export type FiltrarRelatorioFaixaQuery = {
  __typename?: 'Query';
  filtrarRelatorioFaixa?: Array<{
    __typename?: 'Faixa';
    id: number;
    contrato_id: number;
    cidade_id?: number | null;
    local: string;
    identificacao: string;
    sentido: string;
    num_serie: string;
    codigo_cliente?: string | null;
    tipo: number;
    lote?: string | null;
    cod_dnit?: string | null;
    cod_grin?: string | null;
    data_venc_afericao?: string | null;
    contrato?: {
      __typename?: 'Contrato';
      id: number;
      descricao: string;
    } | null;
    tipo_capturas?: Array<{
      __typename?: 'TipoCaptura';
      id: number;
      descricao: string;
      categoria: number;
      ordem?: number | null;
    }> | null;
    cidade?: { __typename?: 'Cidade'; nome: string; uf: string } | null;
    no_laudo?: string | null;
    registros?: Array<{
      __typename?: 'Registro';
      nanoid: string;
      capturas?: Array<{
        __typename?: 'RegistroCaptura';
        nanoid: string;
        tipo_captura_id?: number | null;
        data_hora: string;
        latitude?: string | null;
        longitude?: string | null;
        arquivo?: string | null;
        mime_type?: string | null;
        motivo_ausencia?: string | null;
        motivo_ausencia_obs?: string | null;
        principal: string;
        ativo: string;
        anexo?: string | null;
      }> | null;
    }> | null;
  }> | null;
};

export type FiltrarRotaQueryVariables = Exact<{
  filter: RotaListInput;
}>;

export type FiltrarRotaQuery = {
  __typename?: 'Query';
  filtrarRota?: {
    __typename?: 'RotaDataTable';
    count?: number | null;
    rows?: Array<{
      __typename?: 'Rota';
      id: number;
      descricao: string;
      criacao_usuario_nanoid?: string | null;
      data_hora_criacao: string;
      ativo: string;
      usuario_criacao?: { __typename?: 'Usuario'; nome?: string | null } | null;
    }> | null;
  } | null;
};

export type BuscarRotaPorIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type BuscarRotaPorIdQuery = {
  __typename?: 'Query';
  buscarRotaPorId?: {
    __typename?: 'Rota';
    id: number;
    descricao: string;
    criacao_usuario_nanoid?: string | null;
    atualizacao_usuario_nanoid?: string | null;
    data_hora_criacao: string;
    ativo: string;
  } | null;
};

export type ListarRotaQueryVariables = Exact<{ [key: string]: never }>;

export type ListarRotaQuery = {
  __typename?: 'Query';
  listarRota?: Array<{
    __typename?: 'Rota';
    id: number;
    descricao: string;
  }> | null;
};

export type CriarAlterarRotaMutationVariables = Exact<{
  data: RotaInput;
}>;

export type CriarAlterarRotaMutation = {
  __typename?: 'Mutation';
  criarAlterarRota?: { __typename?: 'Rota'; id: number } | null;
};

export type FiltrarSolicitacaoQueryVariables = Exact<{
  filter: SolicitacaoListInput;
}>;

export type FiltrarSolicitacaoQuery = {
  __typename?: 'Query';
  filtrarSolicitacao?: {
    __typename?: 'SolicitacaoDataTable';
    count?: number | null;
    rows?: Array<{
      __typename?: 'Solicitacao';
      nanoid: string;
      descricao: string;
      status: string;
      criacao_usuario_nanoid?: string | null;
      data_hora_criacao: string;
      origem: string;
      ativo: string;
      usuario_criacao?: { __typename?: 'Usuario'; nome?: string | null } | null;
      faixa?: { __typename?: 'Faixa'; identificacao: string } | null;
      dispositivo?: {
        __typename?: 'Dispositivo';
        identificador?: string | null;
        descricao?: string | null;
      } | null;
    }> | null;
  } | null;
};

export type BuscarSolicitacaoPorIdQueryVariables = Exact<{
  nanoid: Scalars['String']['input'];
}>;

export type BuscarSolicitacaoPorIdQuery = {
  __typename?: 'Query';
  buscarSolicitacaoPorId?: {
    __typename?: 'Solicitacao';
    nanoid: string;
    descricao: string;
    status: string;
    criacao_usuario_nanoid?: string | null;
    atualizacao_usuario_nanoid?: string | null;
    data_hora_criacao: string;
    ativo: string;
  } | null;
};

export type ListarSolicitacaoQueryVariables = Exact<{ [key: string]: never }>;

export type ListarSolicitacaoQuery = {
  __typename?: 'Query';
  listarSolicitacao?: Array<{
    __typename?: 'Solicitacao';
    nanoid: string;
    descricao: string;
  }> | null;
};

export type CriarAlterarSolicitacaoMutationVariables = Exact<{
  data: SolicitacaoInput;
}>;

export type CriarAlterarSolicitacaoMutation = {
  __typename?: 'Mutation';
  criarAlterarSolicitacao?: {
    __typename?: 'Solicitacao';
    nanoid: string;
  } | null;
};

export type CriarVariasSolicitacoesMutationVariables = Exact<{
  data: SolicitacaoInput;
}>;

export type CriarVariasSolicitacoesMutation = {
  __typename?: 'Mutation';
  criarVariasSolicitacoes?: Array<{
    __typename?: 'Solicitacao';
    nanoid: string;
  }> | null;
};

export type FiltrarTipoCapturaQueryVariables = Exact<{
  filter: TipoCapturaListInput;
}>;

export type FiltrarTipoCapturaQuery = {
  __typename?: 'Query';
  filtrarTipoCaptura?: {
    __typename?: 'TipoCapturaDataTable';
    count?: number | null;
    rows?: Array<{
      __typename?: 'TipoCaptura';
      id: number;
      descricao: string;
      categoria: number;
      ordem?: number | null;
      criacao_usuario_nanoid?: string | null;
      data_hora_criacao: string;
      ativo: string;
      usuario_criacao?: { __typename?: 'Usuario'; nome?: string | null } | null;
    }> | null;
  } | null;
};

export type BuscarTipoCapturaPorIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type BuscarTipoCapturaPorIdQuery = {
  __typename?: 'Query';
  buscarTipoCapturaPorId?: {
    __typename?: 'TipoCaptura';
    id: number;
    descricao: string;
    categoria: number;
    criacao_usuario_nanoid?: string | null;
    atualizacao_usuario_nanoid?: string | null;
    data_hora_criacao: string;
    ordem?: number | null;
    ativo: string;
  } | null;
};

export type ListarTipoCapturaQueryVariables = Exact<{ [key: string]: never }>;

export type ListarTipoCapturaQuery = {
  __typename?: 'Query';
  listarTipoCaptura?: Array<{
    __typename?: 'TipoCaptura';
    id: number;
    descricao: string;
  }> | null;
};

export type ListarTipoCapturaPorFaixaQueryVariables = Exact<{
  faixaId: Scalars['Int']['input'];
}>;

export type ListarTipoCapturaPorFaixaQuery = {
  __typename?: 'Query';
  listarTipoCapturaPorFaixa?: Array<{
    __typename?: 'TipoCaptura';
    id: number;
    descricao: string;
  }> | null;
};

export type CriarAlterarTipoCapturaMutationVariables = Exact<{
  data: TipoCapturaInput;
}>;

export type CriarAlterarTipoCapturaMutation = {
  __typename?: 'Mutation';
  criarAlterarTipoCaptura?: { __typename?: 'TipoCaptura'; id: number } | null;
};

export type UploadFileMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  dir: Scalars['String']['input'];
}>;

export type UploadFileMutation = {
  __typename?: 'Mutation';
  uploadFile?: { __typename?: 'LocalFile'; path: string } | null;
};

export type SignUrlQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;

export type SignUrlQuery = {
  __typename?: 'Query';
  signUrl?: { __typename?: 'SignUrl'; signed?: string | null } | null;
};

export type FiltrarUsuarioQueryVariables = Exact<{
  filter: UsuarioListInput;
}>;

export type FiltrarUsuarioQuery = {
  __typename?: 'Query';
  filtrarUsuario?: {
    __typename?: 'UsuarioDataTable';
    count?: number | null;
    rows?: Array<{
      __typename?: 'Usuario';
      nanoid: string;
      nome?: string | null;
      email?: string | null;
      usuario: string;
      ativo?: string | null;
      data_hora_expiracao?: string | null;
      data_hora_criacao?: string | null;
      usuario_criacao?: { __typename?: 'Usuario'; nome?: string | null } | null;
    }> | null;
  } | null;
};

export type UsuarioLogadoQueryVariables = Exact<{ [key: string]: never }>;

export type UsuarioLogadoQuery = {
  __typename?: 'Query';
  usuarioLogado?: {
    __typename?: 'Usuario';
    nanoid: string;
    nome?: string | null;
    usuario: string;
    tipo?: number | null;
    foto?: string | null;
    permissoes?: Array<{ __typename?: 'Permissao'; nanoid: string }> | null;
    grupo_sistema?: {
      __typename?: 'GrupoSistema';
      permissoes?: Array<{ __typename?: 'Permissao'; nanoid: string }> | null;
    } | null;
  } | null;
};

export type LoginQueryVariables = Exact<{
  data: UsuarioLoginInput;
}>;

export type LoginQuery = {
  __typename?: 'Query';
  login?: { __typename?: 'Usuario'; token?: string | null } | null;
};

export type BuscarUsuarioPorIdQueryVariables = Exact<{
  nanoid: Scalars['String']['input'];
}>;

export type BuscarUsuarioPorIdQuery = {
  __typename?: 'Query';
  buscarUsuarioPorId?: {
    __typename?: 'Usuario';
    nanoid: string;
    nome?: string | null;
    usuario: string;
    email?: string | null;
    tipo?: number | null;
    ultimo_acesso?: string | null;
    data_hora_expiracao?: string | null;
    assinatura?: string | null;
    grupo_sistema_id?: number | null;
    foto?: string | null;
    permissoes?: Array<{ __typename?: 'Permissao'; nanoid: string }> | null;
  } | null;
};

export type ListarUsuariosQueryVariables = Exact<{ [key: string]: never }>;

export type ListarUsuariosQuery = {
  __typename?: 'Query';
  listarUsuarios?: Array<{
    __typename?: 'Usuario';
    nanoid: string;
    nome?: string | null;
  }> | null;
};

export type ListarUsuariosRetaguardaQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ListarUsuariosRetaguardaQuery = {
  __typename?: 'Query';
  listarUsuariosRetaguarda?: Array<{
    __typename?: 'Usuario';
    nanoid: string;
    nome?: string | null;
    usuario: string;
  }> | null;
};

export type ListarUsuariosDispositivoQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ListarUsuariosDispositivoQuery = {
  __typename?: 'Query';
  listarUsuariosDispositivo?: Array<{
    __typename?: 'Usuario';
    nanoid: string;
    nome?: string | null;
    usuario: string;
  }> | null;
};

export type CriarAlterarUsuarioMutationVariables = Exact<{
  data: UsuarioInput;
}>;

export type CriarAlterarUsuarioMutation = {
  __typename?: 'Mutation';
  criarAlterarUsuario?: { __typename?: 'Usuario'; nanoid: string } | null;
};

export type AlterarSenhaUsuarioRetaguardaMutationVariables = Exact<{
  data: UsuarioAlterarSenhaInput;
}>;

export type AlterarSenhaUsuarioRetaguardaMutation = {
  __typename?: 'Mutation';
  alterarSenhaUsuarioRetaguarda?: {
    __typename?: 'UsuarioFullData';
    nanoid: string;
  } | null;
};

export type AtivarDesativarUsuariosMutationVariables = Exact<{
  data: UsuariosInput;
}>;

export type AtivarDesativarUsuariosMutation = {
  __typename?: 'Mutation';
  ativarDesativarUsuarios?: Array<{
    __typename?: 'Usuario';
    nanoid: string;
  }> | null;
};

export const FiltrarCidadeDocument = gql`
  query filtrarCidade($filter: CidadeListInput!) {
    filtrarCidade(filter: $filter) {
      count
      rows {
        id
        nome
        uf
        codigo_ibge
        criacao_usuario_nanoid
        data_hora_criacao
        ativo
        usuario_criacao {
          nome
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarCidadeGQL extends Apollo.Query<
  FiltrarCidadeQuery,
  FiltrarCidadeQueryVariables
> {
  override document = FiltrarCidadeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarCidadePorIdDocument = gql`
  query buscarCidadePorId($id: Int!) {
    buscarCidadePorId(id: $id) {
      id
      nome
      uf
      codigo_ibge
      criacao_usuario_nanoid
      atualizacao_usuario_nanoid
      data_hora_criacao
      ativo
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarCidadePorIdGQL extends Apollo.Query<
  BuscarCidadePorIdQuery,
  BuscarCidadePorIdQueryVariables
> {
  override document = BuscarCidadePorIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarCidadeDocument = gql`
  query listarCidade {
    listarCidade {
      id
      nome
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarCidadeGQL extends Apollo.Query<
  ListarCidadeQuery,
  ListarCidadeQueryVariables
> {
  override document = ListarCidadeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CriarAlterarCidadeDocument = gql`
  mutation criarAlterarCidade($data: CidadeInput!) {
    criarAlterarCidade(data: $data) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CriarAlterarCidadeGQL extends Apollo.Mutation<
  CriarAlterarCidadeMutation,
  CriarAlterarCidadeMutationVariables
> {
  override document = CriarAlterarCidadeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FiltrarContratoDocument = gql`
  query filtrarContrato($filter: ContratoListInput!) {
    filtrarContrato(filter: $filter) {
      count
      rows {
        id
        cidade_id
        descricao
        endereco
        periodicidade
        codigo_contrato
        criacao_usuario_nanoid
        atualizacao_usuario_nanoid
        data_hora_criacao
        ativo
        usuario_criacao {
          nome
        }
        cidade {
          nome
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarContratoGQL extends Apollo.Query<
  FiltrarContratoQuery,
  FiltrarContratoQueryVariables
> {
  override document = FiltrarContratoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarContratoPorIdDocument = gql`
  query buscarContratoPorId($id: Int!) {
    buscarContratoPorId(id: $id) {
      id
      cidade_id
      descricao
      endereco
      periodicidade
      codigo_contrato
      rel_exibir_data
      rel_exibir_coordenada
      rel_exibir_cidade
      path_tags
      criacao_usuario_nanoid
      atualizacao_usuario_nanoid
      data_hora_criacao
      ativo
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarContratoPorIdGQL extends Apollo.Query<
  BuscarContratoPorIdQuery,
  BuscarContratoPorIdQueryVariables
> {
  override document = BuscarContratoPorIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarContratoDocument = gql`
  query listarContrato {
    listarContrato {
      id
      descricao
      periodicidade
      rel_exibir_data
      rel_exibir_coordenada
      rel_exibir_cidade
      path_tags
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarContratoGQL extends Apollo.Query<
  ListarContratoQuery,
  ListarContratoQueryVariables
> {
  override document = ListarContratoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CriarAlterarContratoDocument = gql`
  mutation criarAlterarContrato($data: ContratoInput!) {
    criarAlterarContrato(data: $data) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CriarAlterarContratoGQL extends Apollo.Mutation<
  CriarAlterarContratoMutation,
  CriarAlterarContratoMutationVariables
> {
  override document = CriarAlterarContratoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FiltrarContratoZipDocument = gql`
  query filtrarContratoZip($filter: ContratoZipListInput!) {
    filtrarContratoZip(filter: $filter) {
      count
      rows {
        nanoid
        arquivo
        tamanho_mb
        descricao
        status
        mensagem_erro
        data_hora_criacao
        data_hora_finalizacao
        usuario_criacao {
          nome
        }
        contrato {
          descricao
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarContratoZipGQL extends Apollo.Query<
  FiltrarContratoZipQuery,
  FiltrarContratoZipQueryVariables
> {
  override document = FiltrarContratoZipDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GerarZipContratoDocument = gql`
  mutation gerarZipContrato($data: ZipFileInput!) {
    gerarZipContrato(data: $data)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GerarZipContratoGQL extends Apollo.Mutation<
  GerarZipContratoMutation,
  GerarZipContratoMutationVariables
> {
  override document = GerarZipContratoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CriarAlterarContratoZipDocument = gql`
  mutation criarAlterarContratoZip($data: ContratoZipInput!) {
    criarAlterarContratoZip(data: $data) {
      nanoid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CriarAlterarContratoZipGQL extends Apollo.Mutation<
  CriarAlterarContratoZipMutation,
  CriarAlterarContratoZipMutationVariables
> {
  override document = CriarAlterarContratoZipDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FiltrarDashboardDocument = gql`
  query filtrarDashboard($ano: Int!, $mes: Int!) {
    filtrarDashboard(ano: $ano, mes: $mes) {
      numContratos
      numFaixas
      numRegistros
      numSolicitacoesPendentes
      numSolicitacoesFinalizadas
      numProgramacoesExecutadas
      numProgramacoesPendentes
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarDashboardGQL extends Apollo.Query<
  FiltrarDashboardQuery,
  FiltrarDashboardQueryVariables
> {
  override document = FiltrarDashboardDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FiltrarDispositivoDocument = gql`
  query filtrarDispositivo($filter: DispositivoListInput!) {
    filtrarDispositivo(filter: $filter) {
      count
      rows {
        nanoid
        identificador
        descricao
        so
        data_hora_criacao
        data_hora_atualizacao
        ativo
        criacao_usuario_nanoid
        atualizacao_usuario_nanoid
        data_ultima_sincronia
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarDispositivoGQL extends Apollo.Query<
  FiltrarDispositivoQuery,
  FiltrarDispositivoQueryVariables
> {
  override document = FiltrarDispositivoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarDispositivoPorIdDocument = gql`
  query BuscarDispositivoPorId($nanoid: String!) {
    buscarDispositivoPorId(nanoid: $nanoid) {
      nanoid
      identificador
      descricao
      so
      data_hora_criacao
      data_hora_atualizacao
      ativo
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarDispositivoPorIdGQL extends Apollo.Query<
  BuscarDispositivoPorIdQuery,
  BuscarDispositivoPorIdQueryVariables
> {
  override document = BuscarDispositivoPorIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarDispositivosDocument = gql`
  query ListarDispositivos {
    listarDispositivos {
      nanoid
      descricao
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarDispositivosGQL extends Apollo.Query<
  ListarDispositivosQuery,
  ListarDispositivosQueryVariables
> {
  override document = ListarDispositivosDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarDispositivosAtivosDocument = gql`
  query ListarDispositivosAtivos {
    listarDispositivosAtivos {
      nanoid
      identificador
      descricao
      so
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarDispositivosAtivosGQL extends Apollo.Query<
  ListarDispositivosAtivosQuery,
  ListarDispositivosAtivosQueryVariables
> {
  override document = ListarDispositivosAtivosDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarUsuariosLogadosPorDispositivoDocument = gql`
  query ListarUsuariosLogadosPorDispositivo($dispositivoNanoid: String!) {
    listarUsuariosLogadosPorDispositivo(dispositivoNanoid: $dispositivoNanoid) {
      nanoid
      status
      data_hora_entrada
      usuario {
        nome
        usuario
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarUsuariosLogadosPorDispositivoGQL extends Apollo.Query<
  ListarUsuariosLogadosPorDispositivoQuery,
  ListarUsuariosLogadosPorDispositivoQueryVariables
> {
  override document = ListarUsuariosLogadosPorDispositivoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SolicitarLogoutNoDispositivoDocument = gql`
  mutation SolicitarLogoutNoDispositivo($historicoNanoid: String!) {
    solicitarLogoutNoDispositivo(historicoNanoid: $historicoNanoid) {
      nanoid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SolicitarLogoutNoDispositivoGQL extends Apollo.Mutation<
  SolicitarLogoutNoDispositivoMutation,
  SolicitarLogoutNoDispositivoMutationVariables
> {
  override document = SolicitarLogoutNoDispositivoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CriarAlterarDispositivoDocument = gql`
  mutation criarAlterarDispositivo($data: DispositivoInput!) {
    criarAlterarDispositivo(data: $data) {
      nanoid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CriarAlterarDispositivoGQL extends Apollo.Mutation<
  CriarAlterarDispositivoMutation,
  CriarAlterarDispositivoMutationVariables
> {
  override document = CriarAlterarDispositivoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AtivarDesativarDispositivosDocument = gql`
  mutation ativarDesativarDispositivos($data: DispositivosInput!) {
    ativarDesativarDispositivos(data: $data) {
      nanoid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class AtivarDesativarDispositivosGQL extends Apollo.Mutation<
  AtivarDesativarDispositivosMutation,
  AtivarDesativarDispositivosMutationVariables
> {
  override document = AtivarDesativarDispositivosDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarDispositivoKeyPorDispositivoDocument = gql`
  query buscarDispositivoKeyPorDispositivo($nanoid: String!) {
    buscarDispositivoKeyPorDispositivo(nanoid: $nanoid) {
      id
      revogado
      data_hora_revogacao
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarDispositivoKeyPorDispositivoGQL extends Apollo.Query<
  BuscarDispositivoKeyPorDispositivoQuery,
  BuscarDispositivoKeyPorDispositivoQueryVariables
> {
  override document = BuscarDispositivoKeyPorDispositivoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CriarAlterarDispositivoKeyDocument = gql`
  mutation criarAlterarDispositivoKey($data: DispositivoKeyInput!) {
    criarAlterarDispositivoKey(data: $data) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CriarAlterarDispositivoKeyGQL extends Apollo.Mutation<
  CriarAlterarDispositivoKeyMutation,
  CriarAlterarDispositivoKeyMutationVariables
> {
  override document = CriarAlterarDispositivoKeyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FiltrarEventoSiteDocument = gql`
  query filtrarEventoSite($filter: EventoListInput!) {
    filtrarEventoSite(filter: $filter) {
      nanoid
      descricao
      tipo_evento
      data_hora_criacao
      usuario {
        nome
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarEventoSiteGQL extends Apollo.Query<
  FiltrarEventoSiteQuery,
  FiltrarEventoSiteQueryVariables
> {
  override document = FiltrarEventoSiteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FiltrarEventoDispositivoDocument = gql`
  query filtrarEventoDispositivo($filter: EventoListInput!) {
    filtrarEventoDispositivo(filter: $filter) {
      nanoid
      descricao
      tipo_evento
      data_hora_criacao
      usuario {
        nome
      }
      dispositivo {
        descricao
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarEventoDispositivoGQL extends Apollo.Query<
  FiltrarEventoDispositivoQuery,
  FiltrarEventoDispositivoQueryVariables
> {
  override document = FiltrarEventoDispositivoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarEventoSitePorIdDocument = gql`
  query buscarEventoSitePorId($nanoid: String!) {
    buscarEventoSitePorId(nanoid: $nanoid) {
      nanoid
      descricao
      valores_antigos
      valores_novos
      tipo_evento
      data_hora_criacao
      usuario {
        nome
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarEventoSitePorIdGQL extends Apollo.Query<
  BuscarEventoSitePorIdQuery,
  BuscarEventoSitePorIdQueryVariables
> {
  override document = BuscarEventoSitePorIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarEventoDispositivoPorIdDocument = gql`
  query buscarEventoDispositivoPorId($nanoid: String!) {
    buscarEventoDispositivoPorId(nanoid: $nanoid) {
      nanoid
      descricao
      valores_antigos
      valores_novos
      tipo_evento
      data_hora_criacao
      usuario {
        nome
      }
      dispositivo {
        descricao
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarEventoDispositivoPorIdGQL extends Apollo.Query<
  BuscarEventoDispositivoPorIdQuery,
  BuscarEventoDispositivoPorIdQueryVariables
> {
  override document = BuscarEventoDispositivoPorIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FiltrarFaixaDocument = gql`
  query filtrarFaixa($filter: FaixaListInput!) {
    filtrarFaixa(filter: $filter) {
      count
      rows {
        id
        modelo_id
        contrato_id
        regional_id
        rota_id
        local
        identificacao
        sentido
        latitude
        longitude
        num_serie
        codigo_cliente
        lote
        cod_dnit
        cod_grin
        tipo
        data_inicio_operacao
        data_venc_afericao
        data_venc_estudo_tec
        criacao_usuario_nanoid
        atualizacao_usuario_nanoid
        data_hora_criacao
        ativo
        usuario_criacao {
          nome
        }
        modelo {
          descricao
          marca {
            descricao
          }
        }
        contrato {
          descricao
        }
        regional {
          descricao
        }
        rota {
          descricao
        }
        cidade {
          nome
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarFaixaGQL extends Apollo.Query<
  FiltrarFaixaQuery,
  FiltrarFaixaQueryVariables
> {
  override document = FiltrarFaixaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarFaixaPorIdDocument = gql`
  query buscarFaixaPorId($id: Int!) {
    buscarFaixaPorId(id: $id) {
      id
      modelo_id
      contrato_id
      regional_id
      rota_id
      cidade_id
      local
      identificacao
      sentido
      latitude
      longitude
      num_serie
      codigo_cliente
      lote
      cod_dnit
      cod_grin
      tipo
      data_inicio_operacao
      data_venc_afericao
      data_venc_estudo_tec
      criacao_usuario_nanoid
      atualizacao_usuario_nanoid
      data_hora_criacao
      ativo
      data_afericao
      no_laudo
      tipo_capturas {
        id
      }
      FaixaTipoCapturas {
        tipo_captura_id
        replicar_de_faixa_id
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarFaixaPorIdGQL extends Apollo.Query<
  BuscarFaixaPorIdQuery,
  BuscarFaixaPorIdQueryVariables
> {
  override document = BuscarFaixaPorIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarFaixaDocument = gql`
  query listarFaixa {
    listarFaixa {
      id
      identificacao
      num_serie
      codigo_cliente
      contrato {
        descricao
      }
      regional {
        descricao
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarFaixaGQL extends Apollo.Query<
  ListarFaixaQuery,
  ListarFaixaQueryVariables
> {
  override document = ListarFaixaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarFaixaAtivoDocument = gql`
  query listarFaixaAtivo {
    listarFaixaAtivo {
      id
      identificacao
      num_serie
      codigo_cliente
      contrato {
        descricao
      }
      regional {
        descricao
      }
    }
  }
`;
@Injectable({
  providedIn: 'root',
})
export class ListarFaixaAtivoGQL extends Apollo.Query<
  ListarFaixaAtivoQuery,
  ListarFaixaAtivoQueryVariables
> {
  override document = ListarFaixaAtivoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GerarPlanilhaRelatorioExcelMutationVariables = Exact<{
  filter: RelatorioFaixaInput;
}>;

export type GerarPlanilhaRelatorioExcelMutation = {
  __typename?: 'Mutation';
  gerarPlanilhaRelatorioExcel?: RelatorioExcelOutput | null;
};

export const GerarPlanilhaRelatorioExcelDocument = gql`
  mutation gerarPlanilhaRelatorioExcel($filter: RelatorioFaixaInput!) {
    gerarPlanilhaRelatorioExcel(filter: $filter) {
      base64
      fileName
    }
  }
`;
@Injectable({
  providedIn: 'root',
})
export class GerarPlanilhaRelatorioExcelGQL extends Apollo.Mutation<
  GerarPlanilhaRelatorioExcelMutation,
  GerarPlanilhaRelatorioExcelMutationVariables
> {
  override document = GerarPlanilhaRelatorioExcelDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GerarPdfRelatorioFaixaMutationVariables = Exact<{
  filter: RelatorioFaixaPdfInput;
}>;

export type GerarPdfRelatorioFaixaMutation = {
  __typename?: 'Mutation';
  gerarPdfRelatorioFaixa?: RelatorioPdfOutput | null;
};

export type StatusPdfRelatorioFaixaQueryVariables = Exact<{
  jobId: string;
}>;

export type StatusPdfRelatorioFaixaQuery = {
  __typename?: 'Query';
  statusPdfRelatorioFaixa?: RelatorioPdfStatusOutput | null;
};

export const GerarPdfRelatorioFaixaDocument = gql`
  mutation gerarPdfRelatorioFaixa($filter: RelatorioFaixaPdfInput!) {
    gerarPdfRelatorioFaixa(filter: $filter) {
      jobId
    }
  }
`;
@Injectable({
  providedIn: 'root',
})
export class GerarPdfRelatorioFaixaGQL extends Apollo.Mutation<
  GerarPdfRelatorioFaixaMutation,
  GerarPdfRelatorioFaixaMutationVariables
> {
  override document = GerarPdfRelatorioFaixaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const StatusPdfRelatorioFaixaDocument = gql`
  query statusPdfRelatorioFaixa($jobId: String!) {
    statusPdfRelatorioFaixa(jobId: $jobId) {
      status
      url
      fileName
      erro
    }
  }
`;
@Injectable({
  providedIn: 'root',
})
export class StatusPdfRelatorioFaixaGQL extends Apollo.Query<
  StatusPdfRelatorioFaixaQuery,
  StatusPdfRelatorioFaixaQueryVariables
> {
  override document = StatusPdfRelatorioFaixaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CriarAlterarFaixaDocument = gql`
  mutation criarAlterarFaixa($data: FaixaInput!) {
    criarAlterarFaixa(data: $data) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CriarAlterarFaixaGQL extends Apollo.Mutation<
  CriarAlterarFaixaMutation,
  CriarAlterarFaixaMutationVariables
> {
  override document = CriarAlterarFaixaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FiltrarGrupoSistemaDocument = gql`
  query filtrarGrupoSistema($filter: GrupoSistemaListInput!) {
    filtrarGrupoSistema(filter: $filter) {
      count
      rows {
        id
        nome
        descricao
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarGrupoSistemaGQL extends Apollo.Query<
  FiltrarGrupoSistemaQuery,
  FiltrarGrupoSistemaQueryVariables
> {
  override document = FiltrarGrupoSistemaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarGrupoSistemaDocument = gql`
  query listarGrupoSistema {
    listarGrupoSistema {
      id
      nome
      descricao
      permissoes {
        nanoid
        descricao
        categoria
        ativo
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarGrupoSistemaGQL extends Apollo.Query<
  ListarGrupoSistemaQuery,
  ListarGrupoSistemaQueryVariables
> {
  override document = ListarGrupoSistemaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarGrupoSistemaPorIdDocument = gql`
  query buscarGrupoSistemaPorId($id: Int!) {
    buscarGrupoSistemaPorId(id: $id) {
      id
      nome
      descricao
      permissoes {
        nanoid
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarGrupoSistemaPorIdGQL extends Apollo.Query<
  BuscarGrupoSistemaPorIdQuery,
  BuscarGrupoSistemaPorIdQueryVariables
> {
  override document = BuscarGrupoSistemaPorIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CriarAlterarGrupoSistemaDocument = gql`
  mutation criarAlterarGrupoSistema($data: GrupoSistemaInput!) {
    criarAlterarGrupoSistema(data: $data) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CriarAlterarGrupoSistemaGQL extends Apollo.Mutation<
  CriarAlterarGrupoSistemaMutation,
  CriarAlterarGrupoSistemaMutationVariables
> {
  override document = CriarAlterarGrupoSistemaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FiltrarHistoricoAcessoDocument = gql`
  query FiltrarHistoricoAcesso($filter: HistoricoAcessoListInput!) {
    filtrarHistoricoAcesso(filter: $filter) {
      count
      rows {
        nanoid
        data_hora_entrada
        data_hora_saida
        dispositivo {
          descricao
          identificador
        }
        usuario {
          nome
          usuario
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarHistoricoAcessoGQL extends Apollo.Query<
  FiltrarHistoricoAcessoQuery,
  FiltrarHistoricoAcessoQueryVariables
> {
  override document = FiltrarHistoricoAcessoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarHistoricoAcessoPorIdDocument = gql`
  query buscarHistoricoAcessoPorId($nanoid: String!) {
    buscarHistoricoAcessoPorId(nanoid: $nanoid) {
      nanoid
      data_hora_entrada
      data_hora_saida
      usuario {
        nome
        usuario
      }
      dispositivo {
        descricao
        identificador
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarHistoricoAcessoPorIdGQL extends Apollo.Query<
  BuscarHistoricoAcessoPorIdQuery,
  BuscarHistoricoAcessoPorIdQueryVariables
> {
  override document = BuscarHistoricoAcessoPorIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ImportCsvDocument = gql`
  mutation importCsv($file: Upload!, $modelName: String!) {
    importCsv(file: $file, modelName: $modelName) {
      modelName
      created
      updated
      canCreate
      canUpdate
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ImportCsvGQL extends Apollo.Mutation<
  ImportCsvMutation,
  ImportCsvMutationVariables
> {
  override document = ImportCsvDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FiltrarMarcaDocument = gql`
  query filtrarMarca($filter: MarcaListInput!) {
    filtrarMarca(filter: $filter) {
      count
      rows {
        id
        descricao
        criacao_usuario_nanoid
        data_hora_criacao
        ativo
        usuario_criacao {
          nome
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarMarcaGQL extends Apollo.Query<
  FiltrarMarcaQuery,
  FiltrarMarcaQueryVariables
> {
  override document = FiltrarMarcaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarMarcaPorIdDocument = gql`
  query buscarMarcaPorId($id: Int!) {
    buscarMarcaPorId(id: $id) {
      id
      descricao
      criacao_usuario_nanoid
      atualizacao_usuario_nanoid
      data_hora_criacao
      ativo
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarMarcaPorIdGQL extends Apollo.Query<
  BuscarMarcaPorIdQuery,
  BuscarMarcaPorIdQueryVariables
> {
  override document = BuscarMarcaPorIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarMarcaDocument = gql`
  query listarMarca {
    listarMarca {
      id
      descricao
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarMarcaGQL extends Apollo.Query<
  ListarMarcaQuery,
  ListarMarcaQueryVariables
> {
  override document = ListarMarcaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CriarAlterarMarcaDocument = gql`
  mutation criarAlterarMarca($data: MarcaInput!) {
    criarAlterarMarca(data: $data) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CriarAlterarMarcaGQL extends Apollo.Mutation<
  CriarAlterarMarcaMutation,
  CriarAlterarMarcaMutationVariables
> {
  override document = CriarAlterarMarcaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FiltrarModeloDocument = gql`
  query filtrarModelo($filter: ModeloListInput!) {
    filtrarModelo(filter: $filter) {
      count
      rows {
        id
        descricao
        criacao_usuario_nanoid
        data_hora_criacao
        ativo
        usuario_criacao {
          nome
        }
        marca {
          descricao
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarModeloGQL extends Apollo.Query<
  FiltrarModeloQuery,
  FiltrarModeloQueryVariables
> {
  override document = FiltrarModeloDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarModeloPorIdDocument = gql`
  query buscarModeloPorId($id: Int!) {
    buscarModeloPorId(id: $id) {
      id
      descricao
      marca_id
      criacao_usuario_nanoid
      atualizacao_usuario_nanoid
      data_hora_criacao
      ativo
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarModeloPorIdGQL extends Apollo.Query<
  BuscarModeloPorIdQuery,
  BuscarModeloPorIdQueryVariables
> {
  override document = BuscarModeloPorIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarModeloDocument = gql`
  query listarModelo {
    listarModelo {
      id
      descricao
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarModeloGQL extends Apollo.Query<
  ListarModeloQuery,
  ListarModeloQueryVariables
> {
  override document = ListarModeloDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CriarAlterarModeloDocument = gql`
  mutation criarAlterarModelo($data: ModeloInput!) {
    criarAlterarModelo(data: $data) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CriarAlterarModeloGQL extends Apollo.Mutation<
  CriarAlterarModeloMutation,
  CriarAlterarModeloMutationVariables
> {
  override document = CriarAlterarModeloDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FiltrarMotivoAusenciaDocument = gql`
  query filtrarMotivoAusencia($filter: MotivoAusenciaListInput!) {
    filtrarMotivoAusencia(filter: $filter) {
      count
      rows {
        nanoid
        descricao
        criacao_usuario_nanoid
        data_hora_criacao
        ativo
        usuario_criacao {
          nome
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarMotivoAusenciaGQL extends Apollo.Query<
  FiltrarMotivoAusenciaQuery,
  FiltrarMotivoAusenciaQueryVariables
> {
  override document = FiltrarMotivoAusenciaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarMotivoAusenciaPorIdDocument = gql`
  query buscarMotivoAusenciaPorId($nanoid: String!) {
    buscarMotivoAusenciaPorId(nanoid: $nanoid) {
      nanoid
      descricao
      criacao_usuario_nanoid
      atualizacao_usuario_nanoid
      data_hora_criacao
      ativo
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarMotivoAusenciaPorIdGQL extends Apollo.Query<
  BuscarMotivoAusenciaPorIdQuery,
  BuscarMotivoAusenciaPorIdQueryVariables
> {
  override document = BuscarMotivoAusenciaPorIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarMotivoAusenciaDocument = gql`
  query listarMotivoAusencia {
    listarMotivoAusencia {
      nanoid
      descricao
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarMotivoAusenciaGQL extends Apollo.Query<
  ListarMotivoAusenciaQuery,
  ListarMotivoAusenciaQueryVariables
> {
  override document = ListarMotivoAusenciaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CriarAlterarMotivoAusenciaDocument = gql`
  mutation criarAlterarMotivoAusencia($data: MotivoAusenciaInput!) {
    criarAlterarMotivoAusencia(data: $data) {
      nanoid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CriarAlterarMotivoAusenciaGQL extends Apollo.Mutation<
  CriarAlterarMotivoAusenciaMutation,
  CriarAlterarMotivoAusenciaMutationVariables
> {
  override document = CriarAlterarMotivoAusenciaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FiltrarParametroDocument = gql`
  query filtrarParametro($filter: ParametroListInput!) {
    filtrarParametro(filter: $filter) {
      count
      rows {
        id
        tipo
        valor
        tipo_valor
        descricao
        grupo
        data_hora_criacao
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarParametroGQL extends Apollo.Query<
  FiltrarParametroQuery,
  FiltrarParametroQueryVariables
> {
  override document = FiltrarParametroDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarParametroPorIdDocument = gql`
  query buscarParametroPorId($id: Int!) {
    buscarParametroPorId(id: $id) {
      id
      tipo
      valor
      tipo_valor
      descricao
      grupo
      data_hora_criacao
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarParametroPorIdGQL extends Apollo.Query<
  BuscarParametroPorIdQuery,
  BuscarParametroPorIdQueryVariables
> {
  override document = BuscarParametroPorIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarParametroPorTipoDocument = gql`
  query buscarParametroPorTipo($tipo: String!) {
    buscarParametroPorTipo(tipo: $tipo) {
      id
      tipo
      valor
      tipo_valor
      descricao
      grupo
      data_hora_criacao
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarParametroPorTipoGQL extends Apollo.Query<
  BuscarParametroPorTipoQuery,
  BuscarParametroPorTipoQueryVariables
> {
  override document = BuscarParametroPorTipoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarParametroPorTipoDocument = gql`
  query listarParametroPorTipo($tipos: [String!]!) {
    listarParametroPorTipo(tipos: $tipos) {
      id
      tipo
      valor
      tipo_valor
      descricao
      grupo
      data_hora_criacao
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarParametroPorTipoGQL extends Apollo.Query<
  ListarParametroPorTipoQuery,
  ListarParametroPorTipoQueryVariables
> {
  override document = ListarParametroPorTipoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarGrupoDocument = gql`
  query buscarGrupo {
    buscarGrupo {
      grupo
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarGrupoGQL extends Apollo.Query<
  BuscarGrupoQuery,
  BuscarGrupoQueryVariables
> {
  override document = BuscarGrupoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarParametroDocument = gql`
  query listarParametro {
    listarParametro {
      id
      tipo
      valor
      tipo_valor
      descricao
      grupo
      data_hora_criacao
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarParametroGQL extends Apollo.Query<
  ListarParametroQuery,
  ListarParametroQueryVariables
> {
  override document = ListarParametroDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CriarAlterarParametroDocument = gql`
  mutation criarAlterarParametro($data: ParametroInput!) {
    criarAlterarParametro(data: $data) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CriarAlterarParametroGQL extends Apollo.Mutation<
  CriarAlterarParametroMutation,
  CriarAlterarParametroMutationVariables
> {
  override document = CriarAlterarParametroDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarPermissoesDocument = gql`
  query listarPermissoes {
    listarPermissoes {
      nanoid
      descricao
      categoria
      ativo
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarPermissoesGQL extends Apollo.Query<
  ListarPermissoesQuery,
  ListarPermissoesQueryVariables
> {
  override document = ListarPermissoesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FiltrarProgramacaoDocument = gql`
  query filtrarProgramacao($filter: ProgramacaoListInput!) {
    filtrarProgramacao(filter: $filter) {
      count
      rows {
        nanoid
        contrato_id
        faixa_id
        mes
        ano
        periodicidade
        quinzena
        executado
        motivo_ausencia
        motivo_ausencia_obs
        usuario_execucao_nanoid
        data_hora_execucao
        data_hora_criacao
        ativo
        sincronizado
        contrato {
          descricao
        }
        faixa {
          identificacao
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarProgramacaoGQL extends Apollo.Query<
  FiltrarProgramacaoQuery,
  FiltrarProgramacaoQueryVariables
> {
  override document = FiltrarProgramacaoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarProgramacaoPorIdDocument = gql`
  query buscarProgramacaoPorId($nanoid: String!) {
    buscarProgramacaoPorId(nanoid: $nanoid) {
      nanoid
      contrato_id
      faixa_id
      mes
      ano
      periodicidade
      quinzena
      executado
      motivo_ausencia
      motivo_ausencia_obs
      usuario_execucao_nanoid
      data_hora_execucao
      data_hora_criacao
      ativo
      sincronizado
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarProgramacaoPorIdGQL extends Apollo.Query<
  BuscarProgramacaoPorIdQuery,
  BuscarProgramacaoPorIdQueryVariables
> {
  override document = BuscarProgramacaoPorIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GerarProgramacaoDocument = gql`
  query gerarProgramacao {
    gerarProgramacao {
      nanoid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GerarProgramacaoGQL extends Apollo.Query<
  GerarProgramacaoQuery,
  GerarProgramacaoQueryVariables
> {
  override document = GerarProgramacaoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CriarAlterarProgramacaoDocument = gql`
  mutation criarAlterarProgramacao($data: ProgramacaoInput!) {
    criarAlterarProgramacao(data: $data) {
      nanoid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CriarAlterarProgramacaoGQL extends Apollo.Mutation<
  CriarAlterarProgramacaoMutation,
  CriarAlterarProgramacaoMutationVariables
> {
  override document = CriarAlterarProgramacaoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FiltrarRegionalDocument = gql`
  query filtrarRegional($filter: RegionalListInput!) {
    filtrarRegional(filter: $filter) {
      count
      rows {
        id
        descricao
        criacao_usuario_nanoid
        data_hora_criacao
        ativo
        usuario_criacao {
          nome
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarRegionalGQL extends Apollo.Query<
  FiltrarRegionalQuery,
  FiltrarRegionalQueryVariables
> {
  override document = FiltrarRegionalDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarRegionalPorIdDocument = gql`
  query buscarRegionalPorId($id: Int!) {
    buscarRegionalPorId(id: $id) {
      id
      descricao
      criacao_usuario_nanoid
      atualizacao_usuario_nanoid
      data_hora_criacao
      ativo
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarRegionalPorIdGQL extends Apollo.Query<
  BuscarRegionalPorIdQuery,
  BuscarRegionalPorIdQueryVariables
> {
  override document = BuscarRegionalPorIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarRegionalDocument = gql`
  query listarRegional {
    listarRegional {
      id
      descricao
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarRegionalGQL extends Apollo.Query<
  ListarRegionalQuery,
  ListarRegionalQueryVariables
> {
  override document = ListarRegionalDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GerarPlanilhaRelatorioFotosDocument = gql`
  mutation gerarPlanilhaRelatorioFotos($filter: RelatorioFaixaInput!) {
    gerarPlanilhaRelatorioFotos(filter: $filter)
  }
`;
@Injectable({
  providedIn: 'root',
})
export class GerarPlanilhaRelatorioFotosGQL extends Apollo.Mutation<
  GerarPlanilhaRelatorioFotosMutation,
  GerarPlanilhaRelatorioFotosMutationVariables
> {
  override document = GerarPlanilhaRelatorioFotosDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const CriarAlterarRegionalDocument = gql`
  mutation criarAlterarRegional($data: RegionalInput!) {
    criarAlterarRegional(data: $data) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CriarAlterarRegionalGQL extends Apollo.Mutation<
  CriarAlterarRegionalMutation,
  CriarAlterarRegionalMutationVariables
> {
  override document = CriarAlterarRegionalDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FiltrarRegistroDocument = gql`
  query filtrarRegistro($filter: RegistroListInput!) {
    filtrarRegistro(filter: $filter) {
      count
      rows {
        nanoid
        faixa_id
        usuario_nanoid
        dispositivo_nanoid
        data_hora
        modelo_desc
        marca_desc
        ativo
        tipo
        usuario {
          nome
        }
        dispositivo {
          descricao
        }
        solicitacao {
          descricao
        }
        programacao {
          ano
          mes
          quinzena
        }
        faixa {
          identificacao
          sentido
          contrato {
            descricao
          }
          regional {
            descricao
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarRegistroGQL extends Apollo.Query<
  FiltrarRegistroQuery,
  FiltrarRegistroQueryVariables
> {
  override document = FiltrarRegistroDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarRegistroPorIdDocument = gql`
  query buscarRegistroPorId($nanoid: String!) {
    buscarRegistroPorId(nanoid: $nanoid) {
      nanoid
      faixa_id
      solicitacao_nanoid
      programacao_nanoid
      usuario_nanoid
      dispositivo_nanoid
      data_hora
      modelo_desc
      marca_desc
      ativo
      tipo
      faixa {
        identificacao
        num_serie
        sentido
        contrato {
          descricao
        }
        tipo_capturas {
          id
          descricao
        }
        cidade {
          nome
        }
      }
      capturas {
        nanoid
        tipo_captura_id
        data_hora
        latitude
        longitude
        arquivo
        mime_type
        motivo_ausencia
        motivo_ausencia_obs
        principal
        ativo
        anexo
        tipo_captura {
          descricao
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarRegistroPorIdGQL extends Apollo.Query<
  BuscarRegistroPorIdQuery,
  BuscarRegistroPorIdQueryVariables
> {
  override document = BuscarRegistroPorIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarRegistroPorSolicitacaoDocument = gql`
  query listarRegistroPorSolicitacao($solicitacaoNanoid: String!) {
    listarRegistroPorSolicitacao(solicitacao_nanoid: $solicitacaoNanoid) {
      nanoid
      faixa {
        tipo_capturas {
          id
          descricao
        }
      }
      capturas {
        nanoid
        arquivo
        tipo_captura_id
        tipo_captura {
          id
          descricao
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarRegistroPorSolicitacaoGQL extends Apollo.Query<
  ListarRegistroPorSolicitacaoQuery,
  ListarRegistroPorSolicitacaoQueryVariables
> {
  override document = ListarRegistroPorSolicitacaoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CriarAlterarRegistroDocument = gql`
  mutation criarAlterarRegistro($data: RegistroInput!) {
    criarAlterarRegistro(data: $data) {
      nanoid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CriarAlterarRegistroGQL extends Apollo.Mutation<
  CriarAlterarRegistroMutation,
  CriarAlterarRegistroMutationVariables
> {
  override document = CriarAlterarRegistroDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CriarAlterarRegistroCapturaDocument = gql`
  mutation criarAlterarRegistroCaptura($data: RegistroCapturaInput!) {
    criarAlterarRegistroCaptura(data: $data) {
      nanoid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CriarAlterarRegistroCapturaGQL extends Apollo.Mutation<
  CriarAlterarRegistroCapturaMutation,
  CriarAlterarRegistroCapturaMutationVariables
> {
  override document = CriarAlterarRegistroCapturaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const IncluirCapturasNoRegistroDocument = gql`
  mutation incluirCapturasNoRegistro($data: RegistroSolicitacaoInput!) {
    incluirCapturasNoRegistro(data: $data) {
      nanoid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class IncluirCapturasNoRegistroGQL extends Apollo.Mutation<
  IncluirCapturasNoRegistroMutation,
  IncluirCapturasNoRegistroMutationVariables
> {
  override document = IncluirCapturasNoRegistroDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FiltrarRelatorioFaixaDocument = gql`
  query filtrarRelatorioFaixa($filter: RelatorioFaixaInput!) {
    filtrarRelatorioFaixa(filter: $filter) {
      id
      contrato_id
      cidade_id
      local
      identificacao
      sentido
      num_serie
      codigo_cliente
      tipo
      lote
      cod_dnit
      cod_grin
      data_venc_afericao
      data_afericao
      no_laudo
      contrato {
        id
        descricao
      }
      tipo_capturas {
        id
        descricao
        categoria
        ordem
      }
      cidade {
        nome
        uf
      }
      registros {
        nanoid
        capturas {
          nanoid
          tipo_captura_id
          data_hora
          latitude
          longitude
          arquivo
          mime_type
          motivo_ausencia
          motivo_ausencia_obs
          principal
          ativo
          anexo
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarRelatorioFaixaGQL extends Apollo.Query<
  FiltrarRelatorioFaixaQuery,
  FiltrarRelatorioFaixaQueryVariables
> {
  override document = FiltrarRelatorioFaixaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FiltrarRotaDocument = gql`
  query filtrarRota($filter: RotaListInput!) {
    filtrarRota(filter: $filter) {
      count
      rows {
        id
        descricao
        criacao_usuario_nanoid
        data_hora_criacao
        ativo
        usuario_criacao {
          nome
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarRotaGQL extends Apollo.Query<
  FiltrarRotaQuery,
  FiltrarRotaQueryVariables
> {
  override document = FiltrarRotaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarRotaPorIdDocument = gql`
  query buscarRotaPorId($id: Int!) {
    buscarRotaPorId(id: $id) {
      id
      descricao
      criacao_usuario_nanoid
      atualizacao_usuario_nanoid
      data_hora_criacao
      ativo
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarRotaPorIdGQL extends Apollo.Query<
  BuscarRotaPorIdQuery,
  BuscarRotaPorIdQueryVariables
> {
  override document = BuscarRotaPorIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarRotaDocument = gql`
  query listarRota {
    listarRota {
      id
      descricao
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarRotaGQL extends Apollo.Query<
  ListarRotaQuery,
  ListarRotaQueryVariables
> {
  override document = ListarRotaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CriarAlterarRotaDocument = gql`
  mutation criarAlterarRota($data: RotaInput!) {
    criarAlterarRota(data: $data) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CriarAlterarRotaGQL extends Apollo.Mutation<
  CriarAlterarRotaMutation,
  CriarAlterarRotaMutationVariables
> {
  override document = CriarAlterarRotaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FiltrarSolicitacaoDocument = gql`
  query filtrarSolicitacao($filter: SolicitacaoListInput!) {
    filtrarSolicitacao(filter: $filter) {
      count
      rows {
        nanoid
        descricao
        status
        criacao_usuario_nanoid
        data_hora_criacao
        origem
        ativo
        usuario_criacao {
          nome
        }
        faixa {
          identificacao
        }
        dispositivo {
          identificador
          descricao
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarSolicitacaoGQL extends Apollo.Query<
  FiltrarSolicitacaoQuery,
  FiltrarSolicitacaoQueryVariables
> {
  override document = FiltrarSolicitacaoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarSolicitacaoPorIdDocument = gql`
  query buscarSolicitacaoPorId($nanoid: String!) {
    buscarSolicitacaoPorId(nanoid: $nanoid) {
      nanoid
      descricao
      status
      criacao_usuario_nanoid
      atualizacao_usuario_nanoid
      data_hora_criacao
      ativo
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarSolicitacaoPorIdGQL extends Apollo.Query<
  BuscarSolicitacaoPorIdQuery,
  BuscarSolicitacaoPorIdQueryVariables
> {
  override document = BuscarSolicitacaoPorIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarSolicitacaoDocument = gql`
  query listarSolicitacao {
    listarSolicitacao {
      nanoid
      descricao
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarSolicitacaoGQL extends Apollo.Query<
  ListarSolicitacaoQuery,
  ListarSolicitacaoQueryVariables
> {
  override document = ListarSolicitacaoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CriarAlterarSolicitacaoDocument = gql`
  mutation criarAlterarSolicitacao($data: SolicitacaoInput!) {
    criarAlterarSolicitacao(data: $data) {
      nanoid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CriarAlterarSolicitacaoGQL extends Apollo.Mutation<
  CriarAlterarSolicitacaoMutation,
  CriarAlterarSolicitacaoMutationVariables
> {
  override document = CriarAlterarSolicitacaoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CriarVariasSolicitacoesDocument = gql`
  mutation criarVariasSolicitacoes($data: SolicitacaoInput!) {
    criarVariasSolicitacoes(data: $data) {
      nanoid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CriarVariasSolicitacoesGQL extends Apollo.Mutation<
  CriarVariasSolicitacoesMutation,
  CriarVariasSolicitacoesMutationVariables
> {
  override document = CriarVariasSolicitacoesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FiltrarTipoCapturaDocument = gql`
  query filtrarTipoCaptura($filter: TipoCapturaListInput!) {
    filtrarTipoCaptura(filter: $filter) {
      count
      rows {
        id
        descricao
        categoria
        ordem
        criacao_usuario_nanoid
        data_hora_criacao
        ativo
        usuario_criacao {
          nome
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarTipoCapturaGQL extends Apollo.Query<
  FiltrarTipoCapturaQuery,
  FiltrarTipoCapturaQueryVariables
> {
  override document = FiltrarTipoCapturaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarTipoCapturaPorIdDocument = gql`
  query buscarTipoCapturaPorId($id: Int!) {
    buscarTipoCapturaPorId(id: $id) {
      id
      descricao
      categoria
      criacao_usuario_nanoid
      atualizacao_usuario_nanoid
      data_hora_criacao
      ordem
      ativo
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarTipoCapturaPorIdGQL extends Apollo.Query<
  BuscarTipoCapturaPorIdQuery,
  BuscarTipoCapturaPorIdQueryVariables
> {
  override document = BuscarTipoCapturaPorIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarTipoCapturaDocument = gql`
  query listarTipoCaptura {
    listarTipoCaptura {
      id
      descricao
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarTipoCapturaGQL extends Apollo.Query<
  ListarTipoCapturaQuery,
  ListarTipoCapturaQueryVariables
> {
  override document = ListarTipoCapturaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarTipoCapturaPorFaixaDocument = gql`
  query listarTipoCapturaPorFaixa($faixaId: Int!) {
    listarTipoCapturaPorFaixa(faixaId: $faixaId) {
      id
      descricao
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarTipoCapturaPorFaixaGQL extends Apollo.Query<
  ListarTipoCapturaPorFaixaQuery,
  ListarTipoCapturaPorFaixaQueryVariables
> {
  override document = ListarTipoCapturaPorFaixaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CriarAlterarTipoCapturaDocument = gql`
  mutation criarAlterarTipoCaptura($data: TipoCapturaInput!) {
    criarAlterarTipoCaptura(data: $data) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CriarAlterarTipoCapturaGQL extends Apollo.Mutation<
  CriarAlterarTipoCapturaMutation,
  CriarAlterarTipoCapturaMutationVariables
> {
  override document = CriarAlterarTipoCapturaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UploadFileDocument = gql`
  mutation uploadFile($file: Upload!, $dir: String!) {
    uploadFile(file: $file, dir: $dir) {
      path
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UploadFileGQL extends Apollo.Mutation<
  UploadFileMutation,
  UploadFileMutationVariables
> {
  override document = UploadFileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SignUrlDocument = gql`
  query signUrl($url: String!) {
    signUrl(url: $url) {
      signed
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SignUrlGQL extends Apollo.Query<
  SignUrlQuery,
  SignUrlQueryVariables
> {
  override document = SignUrlDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FiltrarUsuarioDocument = gql`
  query filtrarUsuario($filter: UsuarioListInput!) {
    filtrarUsuario(filter: $filter) {
      count
      rows {
        nanoid
        nome
        email
        usuario
        ativo
        data_hora_expiracao
        data_hora_criacao
        usuario_criacao {
          nome
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class FiltrarUsuarioGQL extends Apollo.Query<
  FiltrarUsuarioQuery,
  FiltrarUsuarioQueryVariables
> {
  override document = FiltrarUsuarioDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UsuarioLogadoDocument = gql`
  query usuarioLogado {
    usuarioLogado {
      nanoid
      nome
      usuario
      tipo
      foto
      permissoes {
        nanoid
      }
      grupo_sistema {
        permissoes {
          nanoid
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UsuarioLogadoGQL extends Apollo.Query<
  UsuarioLogadoQuery,
  UsuarioLogadoQueryVariables
> {
  override document = UsuarioLogadoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LoginDocument = gql`
  query login($data: UsuarioLoginInput!) {
    login(data: $data) {
      token
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class LoginGQL extends Apollo.Query<LoginQuery, LoginQueryVariables> {
  override document = LoginDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BuscarUsuarioPorIdDocument = gql`
  query buscarUsuarioPorId($nanoid: String!) {
    buscarUsuarioPorId(nanoid: $nanoid) {
      nanoid
      nome
      usuario
      email
      tipo
      ultimo_acesso
      data_hora_expiracao
      assinatura
      grupo_sistema_id
      foto
      permissoes {
        nanoid
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class BuscarUsuarioPorIdGQL extends Apollo.Query<
  BuscarUsuarioPorIdQuery,
  BuscarUsuarioPorIdQueryVariables
> {
  override document = BuscarUsuarioPorIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarUsuariosDocument = gql`
  query listarUsuarios {
    listarUsuarios {
      nanoid
      nome
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarUsuariosGQL extends Apollo.Query<
  ListarUsuariosQuery,
  ListarUsuariosQueryVariables
> {
  override document = ListarUsuariosDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarUsuariosRetaguardaDocument = gql`
  query listarUsuariosRetaguarda {
    listarUsuariosRetaguarda {
      nanoid
      nome
      usuario
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarUsuariosRetaguardaGQL extends Apollo.Query<
  ListarUsuariosRetaguardaQuery,
  ListarUsuariosRetaguardaQueryVariables
> {
  override document = ListarUsuariosRetaguardaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ListarUsuariosDispositivoDocument = gql`
  query listarUsuariosDispositivo {
    listarUsuariosDispositivo {
      nanoid
      nome
      usuario
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ListarUsuariosDispositivoGQL extends Apollo.Query<
  ListarUsuariosDispositivoQuery,
  ListarUsuariosDispositivoQueryVariables
> {
  override document = ListarUsuariosDispositivoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CriarAlterarUsuarioDocument = gql`
  mutation criarAlterarUsuario($data: UsuarioInput!) {
    criarAlterarUsuario(data: $data) {
      nanoid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CriarAlterarUsuarioGQL extends Apollo.Mutation<
  CriarAlterarUsuarioMutation,
  CriarAlterarUsuarioMutationVariables
> {
  override document = CriarAlterarUsuarioDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AlterarSenhaUsuarioRetaguardaDocument = gql`
  mutation alterarSenhaUsuarioRetaguarda($data: UsuarioAlterarSenhaInput!) {
    alterarSenhaUsuarioRetaguarda(data: $data) {
      nanoid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class AlterarSenhaUsuarioRetaguardaGQL extends Apollo.Mutation<
  AlterarSenhaUsuarioRetaguardaMutation,
  AlterarSenhaUsuarioRetaguardaMutationVariables
> {
  override document = AlterarSenhaUsuarioRetaguardaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AtivarDesativarUsuariosDocument = gql`
  mutation ativarDesativarUsuarios($data: UsuariosInput!) {
    ativarDesativarUsuarios(data: $data) {
      nanoid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class AtivarDesativarUsuariosGQL extends Apollo.Mutation<
  AtivarDesativarUsuariosMutation,
  AtivarDesativarUsuariosMutationVariables
> {
  override document = AtivarDesativarUsuariosDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
